var items = {
  "block.minecraft.acacia_button": "Botón de acacia",
  "block.minecraft.acacia_door": "Porta de acacia",
  "block.minecraft.acacia_fence": "Valado de acacia",
  "block.minecraft.acacia_fence_gate": "Cancela de acacia",
  "block.minecraft.acacia_hanging_sign": "Letreiro colgante de acacia",
  "block.minecraft.acacia_leaves": "Follas de acacia",
  "block.minecraft.acacia_log": "Tronco de acacia",
  "block.minecraft.acacia_planks": "Táboas de acacia",
  "block.minecraft.acacia_pressure_plate": "Placa de presión de acacia",
  "block.minecraft.acacia_sapling": "Gromo de acacia",
  "block.minecraft.acacia_shelf": "Andel de acacia",
  "block.minecraft.acacia_sign": "Letreiro de acacia",
  "block.minecraft.acacia_slab": "Lastra de acacia",
  "block.minecraft.acacia_stairs": "Escaleiras de acacia",
  "block.minecraft.acacia_trapdoor": "Zapón de acacia",
  "block.minecraft.acacia_wall_hanging_sign": "Letreiro colgante de acacia de parede",
  "block.minecraft.acacia_wall_sign": "Letreiro de acacia de parede",
  "block.minecraft.acacia_wood": "Madeira de acacia",
  "block.minecraft.activator_rail": "Raíl activador",
  "block.minecraft.air": "Ar",
  "block.minecraft.allium": "Allo bravo",
  "block.minecraft.amethyst_block": "Bloque de ametista",
  "block.minecraft.amethyst_cluster": "Acio de ametista",
  "block.minecraft.ancient_debris": "Detritos ancestrais",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Lastra de andesita",
  "block.minecraft.andesite_stairs": "Escaleiras de andesita",
  "block.minecraft.andesite_wall": "Muro de andesita",
  "block.minecraft.anvil": "Engra",
  "block.minecraft.attached_melon_stem": "Talo de sandía unido",
  "block.minecraft.attached_pumpkin_stem": "Talo de cabaza unido",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Follas de azalea",
  "block.minecraft.azure_bluet": "Rubiácea",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloque de bambú",
  "block.minecraft.bamboo_button": "Botón de bambú",
  "block.minecraft.bamboo_door": "Porta de bambú",
  "block.minecraft.bamboo_fence": "Valado de bambú",
  "block.minecraft.bamboo_fence_gate": "Cancela de bambú",
  "block.minecraft.bamboo_hanging_sign": "Letreiro colgante de bambú",
  "block.minecraft.bamboo_mosaic": "Mosaico de bambú",
  "block.minecraft.bamboo_mosaic_slab": "Lastra de mosaico de bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Escaleiras de mosaico de bambú",
  "block.minecraft.bamboo_planks": "Táboas de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa de presión de bambú",
  "block.minecraft.bamboo_sapling": "Gromo de bambú",
  "block.minecraft.bamboo_shelf": "Andel de bambú",
  "block.minecraft.bamboo_sign": "Letreiro de bambú",
  "block.minecraft.bamboo_slab": "Lastra de bambú",
  "block.minecraft.bamboo_stairs": "Escaleiras de bambú",
  "block.minecraft.bamboo_trapdoor": "Zapón de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Letreiro colgante de bambú de parede",
  "block.minecraft.bamboo_wall_sign": "Letreiro de bambú de parede",
  "block.minecraft.banner.base.black": "Campo negro",
  "block.minecraft.banner.base.blue": "Campo azul",
  "block.minecraft.banner.base.brown": "Campo marrón",
  "block.minecraft.banner.base.cyan": "Campo ciano",
  "block.minecraft.banner.base.gray": "Campo gris",
  "block.minecraft.banner.base.green": "Campo verde",
  "block.minecraft.banner.base.light_blue": "Campo azul claro",
  "block.minecraft.banner.base.light_gray": "Campo gris claro",
  "block.minecraft.banner.base.lime": "Campo lima",
  "block.minecraft.banner.base.magenta": "Campo maxenta",
  "block.minecraft.banner.base.orange": "Campo laranxa",
  "block.minecraft.banner.base.pink": "Campo rosa",
  "block.minecraft.banner.base.purple": "Campo púrpura",
  "block.minecraft.banner.base.red": "Campo vermello",
  "block.minecraft.banner.base.white": "Campo branco",
  "block.minecraft.banner.base.yellow": "Campo amarelo",
  "block.minecraft.banner.border.black": "Bordadura negra",
  "block.minecraft.banner.border.blue": "Bordadura azul",
  "block.minecraft.banner.border.brown": "Bordadura marrón",
  "block.minecraft.banner.border.cyan": "Bordadura ciano",
  "block.minecraft.banner.border.gray": "Bordadura gris",
  "block.minecraft.banner.border.green": "Bordadura verde",
  "block.minecraft.banner.border.light_blue": "Bordadura azul claro",
  "block.minecraft.banner.border.light_gray": "Bordadura gris claro",
  "block.minecraft.banner.border.lime": "Bordadura lima",
  "block.minecraft.banner.border.magenta": "Bordadura maxenta",
  "block.minecraft.banner.border.orange": "Bordadura laranxa",
  "block.minecraft.banner.border.pink": "Bordadura rosa",
  "block.minecraft.banner.border.purple": "Bordadura púrpura",
  "block.minecraft.banner.border.red": "Bordadura vermella",
  "block.minecraft.banner.border.white": "Bordadura branco",
  "block.minecraft.banner.border.yellow": "Bordadura amarela",
  "block.minecraft.banner.bricks.black": "Mazonado negro",
  "block.minecraft.banner.bricks.blue": "Mazonado azul",
  "block.minecraft.banner.bricks.brown": "Mazonado marrón",
  "block.minecraft.banner.bricks.cyan": "Mazonado ciano",
  "block.minecraft.banner.bricks.gray": "Mazonado gris",
  "block.minecraft.banner.bricks.green": "Mazonado verde",
  "block.minecraft.banner.bricks.light_blue": "Mazonado azul claro",
  "block.minecraft.banner.bricks.light_gray": "Mazonado gris claro",
  "block.minecraft.banner.bricks.lime": "Mazonado lima",
  "block.minecraft.banner.bricks.magenta": "Mazonado maxenta",
  "block.minecraft.banner.bricks.orange": "Mazonado laranxa",
  "block.minecraft.banner.bricks.pink": "Mazonado rosa",
  "block.minecraft.banner.bricks.purple": "Mazonado púrpura",
  "block.minecraft.banner.bricks.red": "Mazonado vermello",
  "block.minecraft.banner.bricks.white": "Mazonado branco",
  "block.minecraft.banner.bricks.yellow": "Mazonado amarelo",
  "block.minecraft.banner.circle.black": "Besante negro",
  "block.minecraft.banner.circle.blue": "Besante azul",
  "block.minecraft.banner.circle.brown": "Besante marrón",
  "block.minecraft.banner.circle.cyan": "Besante ciano",
  "block.minecraft.banner.circle.gray": "Besante gris",
  "block.minecraft.banner.circle.green": "Besante verde",
  "block.minecraft.banner.circle.light_blue": "Besante azul claro",
  "block.minecraft.banner.circle.light_gray": "Besante gris claro",
  "block.minecraft.banner.circle.lime": "Besante lima",
  "block.minecraft.banner.circle.magenta": "Besante maxenta",
  "block.minecraft.banner.circle.orange": "Besante laranxa",
  "block.minecraft.banner.circle.pink": "Besante rosa",
  "block.minecraft.banner.circle.purple": "Besante púrpura",
  "block.minecraft.banner.circle.red": "Besante vermello",
  "block.minecraft.banner.circle.white": "Besante branco",
  "block.minecraft.banner.circle.yellow": "Besante amarelo",
  "block.minecraft.banner.creeper.black": "Estampado negro de creeper",
  "block.minecraft.banner.creeper.blue": "Estampado azul de creeper",
  "block.minecraft.banner.creeper.brown": "Estampado marrón de creeper",
  "block.minecraft.banner.creeper.cyan": "Estampado ciano de creeper",
  "block.minecraft.banner.creeper.gray": "Estampado gris de creeper",
  "block.minecraft.banner.creeper.green": "Estampado verde de creeper",
  "block.minecraft.banner.creeper.light_blue": "Estampado azul claro de creeper",
  "block.minecraft.banner.creeper.light_gray": "Estampado gris claro de creeper",
  "block.minecraft.banner.creeper.lime": "Estampado lima de creeper",
  "block.minecraft.banner.creeper.magenta": "Estampado maxenta de creeper",
  "block.minecraft.banner.creeper.orange": "Estampado laranxa de creeper",
  "block.minecraft.banner.creeper.pink": "Estampado rosa de creeper",
  "block.minecraft.banner.creeper.purple": "Estampado púrpura de creeper",
  "block.minecraft.banner.creeper.red": "Estampado vermello de creeper",
  "block.minecraft.banner.creeper.white": "Estampado branco de creeper",
  "block.minecraft.banner.creeper.yellow": "Estampado amarelo de creeper",
  "block.minecraft.banner.cross.black": "Sautor negro",
  "block.minecraft.banner.cross.blue": "Sautor azul",
  "block.minecraft.banner.cross.brown": "Sautor marrón",
  "block.minecraft.banner.cross.cyan": "Sautor ciano",
  "block.minecraft.banner.cross.gray": "Sautor gris",
  "block.minecraft.banner.cross.green": "Sautor verde",
  "block.minecraft.banner.cross.light_blue": "Sautor azul claro",
  "block.minecraft.banner.cross.light_gray": "Sautor gris claro",
  "block.minecraft.banner.cross.lime": "Sautor lima",
  "block.minecraft.banner.cross.magenta": "Sautor maxenta",
  "block.minecraft.banner.cross.orange": "Sautor laranxa",
  "block.minecraft.banner.cross.pink": "Sautor rosa",
  "block.minecraft.banner.cross.purple": "Sautor púrpura",
  "block.minecraft.banner.cross.red": "Sautor vermello",
  "block.minecraft.banner.cross.white": "Sautor branco",
  "block.minecraft.banner.cross.yellow": "Sautor amarelo",
  "block.minecraft.banner.curly_border.black": "Bordadura negro dentado",
  "block.minecraft.banner.curly_border.blue": "Bordadura azul dentada",
  "block.minecraft.banner.curly_border.brown": "Bordadura marrón dentada",
  "block.minecraft.banner.curly_border.cyan": "Bordadura ciano dentada",
  "block.minecraft.banner.curly_border.gray": "Bordadura gris dentada",
  "block.minecraft.banner.curly_border.green": "Bordadura verdedentada",
  "block.minecraft.banner.curly_border.light_blue": "Bordadura azul claro dentada",
  "block.minecraft.banner.curly_border.light_gray": "Bordadura gris claro dentada",
  "block.minecraft.banner.curly_border.lime": "Bordadura lima dentada",
  "block.minecraft.banner.curly_border.magenta": "Bordadura maxenta dentada",
  "block.minecraft.banner.curly_border.orange": "Bordadura laranxa dentada",
  "block.minecraft.banner.curly_border.pink": "Bordadura rosa dentada",
  "block.minecraft.banner.curly_border.purple": "Bordadura púrpura dentada",
  "block.minecraft.banner.curly_border.red": "Bordadura vermella dentada",
  "block.minecraft.banner.curly_border.white": "Bordadura branca dentada",
  "block.minecraft.banner.curly_border.yellow": "Bordadura amarela dentada",
  "block.minecraft.banner.diagonal_left.black": "Tallada negra a sinistra",
  "block.minecraft.banner.diagonal_left.blue": "Tallada azul a sinistra",
  "block.minecraft.banner.diagonal_left.brown": "Tallada marrón a sinistra",
  "block.minecraft.banner.diagonal_left.cyan": "Tallada ciano a sinistra",
  "block.minecraft.banner.diagonal_left.gray": "Tallada gris a sinistra",
  "block.minecraft.banner.diagonal_left.green": "Tallada verde a sinistra",
  "block.minecraft.banner.diagonal_left.light_blue": "Tallada azul claro a sinistra",
  "block.minecraft.banner.diagonal_left.light_gray": "Tallada gris claro a sinistra",
  "block.minecraft.banner.diagonal_left.lime": "Tallada lima a sinistra",
  "block.minecraft.banner.diagonal_left.magenta": "Tallada maxenta a sinistra",
  "block.minecraft.banner.diagonal_left.orange": "Tallada laranxa a sinistra",
  "block.minecraft.banner.diagonal_left.pink": "Tallada rosa a sinistra",
  "block.minecraft.banner.diagonal_left.purple": "Tallada púrpura a sinistra",
  "block.minecraft.banner.diagonal_left.red": "Tallada vermella a sinistra",
  "block.minecraft.banner.diagonal_left.white": "Tallada branca a sinistra",
  "block.minecraft.banner.diagonal_left.yellow": "Tallada amarela a sinistra",
  "block.minecraft.banner.diagonal_right.black": "Tallada negra",
  "block.minecraft.banner.diagonal_right.blue": "Tallada azul",
  "block.minecraft.banner.diagonal_right.brown": "Tallada marrón",
  "block.minecraft.banner.diagonal_right.cyan": "Tallada ciano",
  "block.minecraft.banner.diagonal_right.gray": "Tallada gris",
  "block.minecraft.banner.diagonal_right.green": "Tallada verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Tallada azul claro",
  "block.minecraft.banner.diagonal_right.light_gray": "Tallada gris claro",
  "block.minecraft.banner.diagonal_right.lime": "Tallada lima",
  "block.minecraft.banner.diagonal_right.magenta": "Tallada maxenta",
  "block.minecraft.banner.diagonal_right.orange": "Tallada laranxa",
  "block.minecraft.banner.diagonal_right.pink": "Tallada rosa",
  "block.minecraft.banner.diagonal_right.purple": "Tallada púrpura",
  "block.minecraft.banner.diagonal_right.red": "Tallada vermella",
  "block.minecraft.banner.diagonal_right.white": "Tallada branca",
  "block.minecraft.banner.diagonal_right.yellow": "Tallada amarela",
  "block.minecraft.banner.diagonal_up_left.black": "Tallada negra invertida",
  "block.minecraft.banner.diagonal_up_left.blue": "Tallada azul invertida",
  "block.minecraft.banner.diagonal_up_left.brown": "Tallada marrón invertida",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tallada ciano invertida",
  "block.minecraft.banner.diagonal_up_left.gray": "Tallada gris invertida",
  "block.minecraft.banner.diagonal_up_left.green": "Tallada verde invertida",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Tallada azul claro invertida",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Tallada gris claro invertida",
  "block.minecraft.banner.diagonal_up_left.lime": "Tallada lima invertida",
  "block.minecraft.banner.diagonal_up_left.magenta": "Tallada maxenta invertida",
  "block.minecraft.banner.diagonal_up_left.orange": "Tallada laranxa invertida",
  "block.minecraft.banner.diagonal_up_left.pink": "Tallada rosa invertida",
  "block.minecraft.banner.diagonal_up_left.purple": "Tallada púrpura invertida",
  "block.minecraft.banner.diagonal_up_left.red": "Tallada vermella invertida",
  "block.minecraft.banner.diagonal_up_left.white": "Tallada branca invertida",
  "block.minecraft.banner.diagonal_up_left.yellow": "Tallada amarela invertida",
  "block.minecraft.banner.diagonal_up_right.black": "Tallada negra invertido a sinistra",
  "block.minecraft.banner.diagonal_up_right.blue": "Tallada azul invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.brown": "Tallada marrón invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tallada ciano invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.gray": "Tallada gris invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.green": "Tallada verde invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tallada azul claro invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tallada gris claro invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.lime": "Tallada lima invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tallada maxenta invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.orange": "Tallada laranxa invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.pink": "Tallada rosa invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.purple": "Tallada púrpura invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.red": "Tallada vermella invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.white": "Tallada branca invertida a sinistra",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tallada amarela invertida a sinistra",
  "block.minecraft.banner.flow.black": "Espiral negra",
  "block.minecraft.banner.flow.blue": "Espiral azul",
  "block.minecraft.banner.flow.brown": "Espiral marrón",
  "block.minecraft.banner.flow.cyan": "Espiral ciano",
  "block.minecraft.banner.flow.gray": "Espiral gris",
  "block.minecraft.banner.flow.green": "Espiral verde",
  "block.minecraft.banner.flow.light_blue": "Espiral azul claro",
  "block.minecraft.banner.flow.light_gray": "Espiral gris claro",
  "block.minecraft.banner.flow.lime": "Espiral lima",
  "block.minecraft.banner.flow.magenta": "Espiral maxenta",
  "block.minecraft.banner.flow.orange": "Espiral laranxa",
  "block.minecraft.banner.flow.pink": "Espiral rosa",
  "block.minecraft.banner.flow.purple": "Espiral púrpura",
  "block.minecraft.banner.flow.red": "Espiral vermella",
  "block.minecraft.banner.flow.white": "Espiral branca",
  "block.minecraft.banner.flow.yellow": "Espiral amarela",
  "block.minecraft.banner.flower.black": "Estampado negro de flor",
  "block.minecraft.banner.flower.blue": "Estampado azul de flor",
  "block.minecraft.banner.flower.brown": "Estampado marrón de flor",
  "block.minecraft.banner.flower.cyan": "Estampado ciano de flor",
  "block.minecraft.banner.flower.gray": "Estampado gris de flor",
  "block.minecraft.banner.flower.green": "Estampado verde de flor",
  "block.minecraft.banner.flower.light_blue": "Estampado azul claro de flor",
  "block.minecraft.banner.flower.light_gray": "Estampado gris claro de flor",
  "block.minecraft.banner.flower.lime": "Estampado lima de flor",
  "block.minecraft.banner.flower.magenta": "Estampado maxenta de flor",
  "block.minecraft.banner.flower.orange": "Estampado laranxa de flor",
  "block.minecraft.banner.flower.pink": "Estampado rosa de flor",
  "block.minecraft.banner.flower.purple": "Estampado púrpura de flor",
  "block.minecraft.banner.flower.red": "Estampado vermello de flor",
  "block.minecraft.banner.flower.white": "Estampado branco de flor",
  "block.minecraft.banner.flower.yellow": "Estampado amarelo de flor",
  "block.minecraft.banner.globe.black": "Planeta negro",
  "block.minecraft.banner.globe.blue": "Planeta azul",
  "block.minecraft.banner.globe.brown": "Planeta marrón",
  "block.minecraft.banner.globe.cyan": "Planeta ciano",
  "block.minecraft.banner.globe.gray": "Planeta gris",
  "block.minecraft.banner.globe.green": "Planeta verde",
  "block.minecraft.banner.globe.light_blue": "Planeta azul claro",
  "block.minecraft.banner.globe.light_gray": "Planeta gris claro",
  "block.minecraft.banner.globe.lime": "Planeta lima",
  "block.minecraft.banner.globe.magenta": "Planeta maxenta",
  "block.minecraft.banner.globe.orange": "Planeta laranxa",
  "block.minecraft.banner.globe.pink": "Planeta rosa",
  "block.minecraft.banner.globe.purple": "Planeta púrpura",
  "block.minecraft.banner.globe.red": "Planeta vermello",
  "block.minecraft.banner.globe.white": "Planeta branco",
  "block.minecraft.banner.globe.yellow": "Planeta amarelo",
  "block.minecraft.banner.gradient.black": "Gradiente negro",
  "block.minecraft.banner.gradient.blue": "Gradiente azul",
  "block.minecraft.banner.gradient.brown": "Gradiente marrón",
  "block.minecraft.banner.gradient.cyan": "Gradiente ciano",
  "block.minecraft.banner.gradient.gray": "Gradiente gris",
  "block.minecraft.banner.gradient.green": "Gradiente verde",
  "block.minecraft.banner.gradient.light_blue": "Gradiente azul claro",
  "block.minecraft.banner.gradient.light_gray": "Gradiente gris claro",
  "block.minecraft.banner.gradient.lime": "Gradiente lima",
  "block.minecraft.banner.gradient.magenta": "Gradiente maxenta",
  "block.minecraft.banner.gradient.orange": "Gradiente laranxa",
  "block.minecraft.banner.gradient.pink": "Gradiente rosa",
  "block.minecraft.banner.gradient.purple": "Gradiente púrpura",
  "block.minecraft.banner.gradient.red": "Gradiente vermello",
  "block.minecraft.banner.gradient.white": "Gradiente branco",
  "block.minecraft.banner.gradient.yellow": "Gradiente amarelo",
  "block.minecraft.banner.gradient_up.black": "Gradiente negro en base",
  "block.minecraft.banner.gradient_up.blue": "Gradiente azul en base",
  "block.minecraft.banner.gradient_up.brown": "Gradiente marrón en base",
  "block.minecraft.banner.gradient_up.cyan": "Gradiente ciano en base",
  "block.minecraft.banner.gradient_up.gray": "Gradiente gris en base",
  "block.minecraft.banner.gradient_up.green": "Gradiente verde en base",
  "block.minecraft.banner.gradient_up.light_blue": "Gradiente azul claro en base",
  "block.minecraft.banner.gradient_up.light_gray": "Gradiente gris claro en base",
  "block.minecraft.banner.gradient_up.lime": "Gradiente lima en base",
  "block.minecraft.banner.gradient_up.magenta": "Gradiente maxenta en base",
  "block.minecraft.banner.gradient_up.orange": "Gradiente laranxa en base",
  "block.minecraft.banner.gradient_up.pink": "Gradiente rosa en base",
  "block.minecraft.banner.gradient_up.purple": "Gradiente púrpura en base",
  "block.minecraft.banner.gradient_up.red": "Gradiente vermello en base",
  "block.minecraft.banner.gradient_up.white": "Gradiente branco en base",
  "block.minecraft.banner.gradient_up.yellow": "Gradiente amarelo en base",
  "block.minecraft.banner.guster.black": "Remuíño negro",
  "block.minecraft.banner.guster.blue": "Remuíño azul",
  "block.minecraft.banner.guster.brown": "Remuíño marrón",
  "block.minecraft.banner.guster.cyan": "Remuíño ciano",
  "block.minecraft.banner.guster.gray": "Remuíño gris",
  "block.minecraft.banner.guster.green": "Remuíño verde",
  "block.minecraft.banner.guster.light_blue": "Remuíño azul claro",
  "block.minecraft.banner.guster.light_gray": "Remuíño gris claro",
  "block.minecraft.banner.guster.lime": "Remuíño lima",
  "block.minecraft.banner.guster.magenta": "Remuíño maxenta",
  "block.minecraft.banner.guster.orange": "Remuíño laranxa",
  "block.minecraft.banner.guster.pink": "Remuíño rosa",
  "block.minecraft.banner.guster.purple": "Remuíño púrpura",
  "block.minecraft.banner.guster.red": "Remuíño vermello",
  "block.minecraft.banner.guster.white": "Remuíño branco",
  "block.minecraft.banner.guster.yellow": "Remuíño amarelo",
  "block.minecraft.banner.half_horizontal.black": "Cortado negro",
  "block.minecraft.banner.half_horizontal.blue": "Cortado azul",
  "block.minecraft.banner.half_horizontal.brown": "Cortado marrón",
  "block.minecraft.banner.half_horizontal.cyan": "Cortado ciano",
  "block.minecraft.banner.half_horizontal.gray": "Cortado gris",
  "block.minecraft.banner.half_horizontal.green": "Cortado verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Cortado azul claro",
  "block.minecraft.banner.half_horizontal.light_gray": "Cortado gris claro",
  "block.minecraft.banner.half_horizontal.lime": "Cortado lima",
  "block.minecraft.banner.half_horizontal.magenta": "Cortado maxenta",
  "block.minecraft.banner.half_horizontal.orange": "Cortado laranxa",
  "block.minecraft.banner.half_horizontal.pink": "Cortado rosa",
  "block.minecraft.banner.half_horizontal.purple": "Cortado púrpura",
  "block.minecraft.banner.half_horizontal.red": "Cortado vermello",
  "block.minecraft.banner.half_horizontal.white": "Cortado branco",
  "block.minecraft.banner.half_horizontal.yellow": "Cortado amarelo",
  "block.minecraft.banner.half_horizontal_bottom.black": "Cortado negro invertido",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Cortado azul invertido",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Cortado marrón invertido",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cortado ciano invertido",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Cortado gris invertido",
  "block.minecraft.banner.half_horizontal_bottom.green": "Cortado verde invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cortado azul claro invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Cortado gris claro invertido",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Cortado lima invertido",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Cortado maxenta invertido",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Cortado laranxa invertido",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Cortado rosa invertido",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Cortado púrpura invertido",
  "block.minecraft.banner.half_horizontal_bottom.red": "Cortado vermello invertido",
  "block.minecraft.banner.half_horizontal_bottom.white": "Cortado branco invertido",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Cortado amarelo invertido",
  "block.minecraft.banner.half_vertical.black": "Partido negro",
  "block.minecraft.banner.half_vertical.blue": "Partido azul",
  "block.minecraft.banner.half_vertical.brown": "Partido marrón",
  "block.minecraft.banner.half_vertical.cyan": "Partido ciano",
  "block.minecraft.banner.half_vertical.gray": "Partido gris",
  "block.minecraft.banner.half_vertical.green": "Partido verde",
  "block.minecraft.banner.half_vertical.light_blue": "Partido azul claro",
  "block.minecraft.banner.half_vertical.light_gray": "Partido gris claro",
  "block.minecraft.banner.half_vertical.lime": "Partido lima",
  "block.minecraft.banner.half_vertical.magenta": "Partido maxenta",
  "block.minecraft.banner.half_vertical.orange": "Partido laranxa",
  "block.minecraft.banner.half_vertical.pink": "Partido rosa",
  "block.minecraft.banner.half_vertical.purple": "Partido púrpura",
  "block.minecraft.banner.half_vertical.red": "Partido vermello",
  "block.minecraft.banner.half_vertical.white": "Partido branco",
  "block.minecraft.banner.half_vertical.yellow": "Partido amarelo",
  "block.minecraft.banner.half_vertical_right.black": "Partido negro invertido",
  "block.minecraft.banner.half_vertical_right.blue": "Partido azul invertido",
  "block.minecraft.banner.half_vertical_right.brown": "Partido marrón invertido",
  "block.minecraft.banner.half_vertical_right.cyan": "Partido ciano invertido",
  "block.minecraft.banner.half_vertical_right.gray": "Partido gris invertido",
  "block.minecraft.banner.half_vertical_right.green": "Partido verde invertido",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partido azul claro invertido",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partido gris claro invertido",
  "block.minecraft.banner.half_vertical_right.lime": "Partido lima invertido",
  "block.minecraft.banner.half_vertical_right.magenta": "Partido maxenta invertido",
  "block.minecraft.banner.half_vertical_right.orange": "Partido laranxa invertido",
  "block.minecraft.banner.half_vertical_right.pink": "Partido rosa invertido",
  "block.minecraft.banner.half_vertical_right.purple": "Partido púrpura invertido",
  "block.minecraft.banner.half_vertical_right.red": "Partido vermello invertido",
  "block.minecraft.banner.half_vertical_right.white": "Partido branco invertido",
  "block.minecraft.banner.half_vertical_right.yellow": "Partido amarelo invertido",
  "block.minecraft.banner.mojang.black": "Símbolo negro",
  "block.minecraft.banner.mojang.blue": "Símbolo azul",
  "block.minecraft.banner.mojang.brown": "Símbolo marrón",
  "block.minecraft.banner.mojang.cyan": "Símbolo ciano",
  "block.minecraft.banner.mojang.gray": "Símbolo gris",
  "block.minecraft.banner.mojang.green": "Símbolo verde",
  "block.minecraft.banner.mojang.light_blue": "Símbolo azul claro",
  "block.minecraft.banner.mojang.light_gray": "Símbolo gris claro",
  "block.minecraft.banner.mojang.lime": "Símbolo lima",
  "block.minecraft.banner.mojang.magenta": "Símbolo maxenta",
  "block.minecraft.banner.mojang.orange": "Símbolo laranxa",
  "block.minecraft.banner.mojang.pink": "Símbolo rosa",
  "block.minecraft.banner.mojang.purple": "Símbolo púrpura",
  "block.minecraft.banner.mojang.red": "Símbolo vermello",
  "block.minecraft.banner.mojang.white": "Símbolo branco",
  "block.minecraft.banner.mojang.yellow": "Símbolo amarelo",
  "block.minecraft.banner.piglin.black": "Fociño negro",
  "block.minecraft.banner.piglin.blue": "Fociño azul",
  "block.minecraft.banner.piglin.brown": "Fociño marrón",
  "block.minecraft.banner.piglin.cyan": "Fociño ciano",
  "block.minecraft.banner.piglin.gray": "Fociño gris",
  "block.minecraft.banner.piglin.green": "Fociño verde",
  "block.minecraft.banner.piglin.light_blue": "Fociño azul claro",
  "block.minecraft.banner.piglin.light_gray": "Fociño gris claro",
  "block.minecraft.banner.piglin.lime": "Fociño lima",
  "block.minecraft.banner.piglin.magenta": "Fociño maxenta",
  "block.minecraft.banner.piglin.orange": "Fociño laranxa",
  "block.minecraft.banner.piglin.pink": "Fociño rosa",
  "block.minecraft.banner.piglin.purple": "Fociño púrpura",
  "block.minecraft.banner.piglin.red": "Fociño vermello",
  "block.minecraft.banner.piglin.white": "Fociño branco",
  "block.minecraft.banner.piglin.yellow": "Fociño amarelo",
  "block.minecraft.banner.rhombus.black": "Losanxe negro",
  "block.minecraft.banner.rhombus.blue": "Losanxe azul",
  "block.minecraft.banner.rhombus.brown": "Losanxe marrón",
  "block.minecraft.banner.rhombus.cyan": "Losanxe ciano",
  "block.minecraft.banner.rhombus.gray": "Losanxe gris",
  "block.minecraft.banner.rhombus.green": "Losanxe verde",
  "block.minecraft.banner.rhombus.light_blue": "Losanxe azul claro",
  "block.minecraft.banner.rhombus.light_gray": "Losanxe gris claro",
  "block.minecraft.banner.rhombus.lime": "Losanxe lima",
  "block.minecraft.banner.rhombus.magenta": "Losanxe maxenta",
  "block.minecraft.banner.rhombus.orange": "Losanxe laranxa",
  "block.minecraft.banner.rhombus.pink": "Losanxe rosa",
  "block.minecraft.banner.rhombus.purple": "Losanxe púrpura",
  "block.minecraft.banner.rhombus.red": "Losanxe vermello",
  "block.minecraft.banner.rhombus.white": "Losanxe branco",
  "block.minecraft.banner.rhombus.yellow": "Losanxe amarelo",
  "block.minecraft.banner.skull.black": "Estampado negro de caveira",
  "block.minecraft.banner.skull.blue": "Estampado azul de caveira",
  "block.minecraft.banner.skull.brown": "Estampado marrón de caveira",
  "block.minecraft.banner.skull.cyan": "Estampado ciano de caveira",
  "block.minecraft.banner.skull.gray": "Estampado gris de caveira",
  "block.minecraft.banner.skull.green": "Estampado verde de caveira",
  "block.minecraft.banner.skull.light_blue": "Estampado azul claro de caveira",
  "block.minecraft.banner.skull.light_gray": "Estampado gris claro de caveira",
  "block.minecraft.banner.skull.lime": "Estampado lima de caveira",
  "block.minecraft.banner.skull.magenta": "Estampado maxenta de caveira",
  "block.minecraft.banner.skull.orange": "Estampado laranxa de caveira",
  "block.minecraft.banner.skull.pink": "Estampado rosa de caveira",
  "block.minecraft.banner.skull.purple": "Estampado púrpura de caveira",
  "block.minecraft.banner.skull.red": "Estampado vermello de caveira",
  "block.minecraft.banner.skull.white": "Estampado branco de caveira",
  "block.minecraft.banner.skull.yellow": "Estampado amarelo de caveira",
  "block.minecraft.banner.small_stripes.black": "Barra negra",
  "block.minecraft.banner.small_stripes.blue": "Barra azul",
  "block.minecraft.banner.small_stripes.brown": "Barra marrón",
  "block.minecraft.banner.small_stripes.cyan": "Barra ciano",
  "block.minecraft.banner.small_stripes.gray": "Barra gris",
  "block.minecraft.banner.small_stripes.green": "Barra verde",
  "block.minecraft.banner.small_stripes.light_blue": "Barra azul claro",
  "block.minecraft.banner.small_stripes.light_gray": "Barra gris claro",
  "block.minecraft.banner.small_stripes.lime": "Barra lima",
  "block.minecraft.banner.small_stripes.magenta": "Bastonado maxenta",
  "block.minecraft.banner.small_stripes.orange": "Barra laranxa",
  "block.minecraft.banner.small_stripes.pink": "Barra rosa",
  "block.minecraft.banner.small_stripes.purple": "Barra púrpura",
  "block.minecraft.banner.small_stripes.red": "Barra vermella",
  "block.minecraft.banner.small_stripes.white": "Barra branca",
  "block.minecraft.banner.small_stripes.yellow": "Barra amarela",
  "block.minecraft.banner.square_bottom_left.black": "Cantón negro en base a destra",
  "block.minecraft.banner.square_bottom_left.blue": "Cantón azul en base a destra",
  "block.minecraft.banner.square_bottom_left.brown": "Cantón marrón en base a destra",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantón ciano en base a destra",
  "block.minecraft.banner.square_bottom_left.gray": "Cantón gris en base a destra",
  "block.minecraft.banner.square_bottom_left.green": "Cantón verde en base a destra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantón azul claro en base a destra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantón gris claro en base a destra",
  "block.minecraft.banner.square_bottom_left.lime": "Cantón lima en base a destra",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantón maxenta en base a destra",
  "block.minecraft.banner.square_bottom_left.orange": "Cantón laranxa en base a destra",
  "block.minecraft.banner.square_bottom_left.pink": "Cantón rosa en base a destra",
  "block.minecraft.banner.square_bottom_left.purple": "Cantón púrpura en base a destra",
  "block.minecraft.banner.square_bottom_left.red": "Cantón vermello en base a destra",
  "block.minecraft.banner.square_bottom_left.white": "Cantón branco en base a destra",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantón amarelo en base a destra",
  "block.minecraft.banner.square_bottom_right.black": "Cantón negro en base a sinistra",
  "block.minecraft.banner.square_bottom_right.blue": "Cantón azul en base a sinistra",
  "block.minecraft.banner.square_bottom_right.brown": "Cantón marrón en base a sinistra",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantón ciano en base a sinistra",
  "block.minecraft.banner.square_bottom_right.gray": "Cantón gris en base a sinistra",
  "block.minecraft.banner.square_bottom_right.green": "Cantón verde en base a sinistra",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantón azul claro en base a sinistra",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantón gris claro en base a sinistra",
  "block.minecraft.banner.square_bottom_right.lime": "Cantón lima en base a sinistra",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantón maxenta en base a sinistra",
  "block.minecraft.banner.square_bottom_right.orange": "Cantón laranxa en base a sinistra",
  "block.minecraft.banner.square_bottom_right.pink": "Cantón rosa en base a sinistra",
  "block.minecraft.banner.square_bottom_right.purple": "Cantón púrpura en base a sinistra",
  "block.minecraft.banner.square_bottom_right.red": "Cantón vermello en base a sinistra",
  "block.minecraft.banner.square_bottom_right.white": "Cantón branco en base a sinistra",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantón amarelo en base a sinistra",
  "block.minecraft.banner.square_top_left.black": "Cantón negro en xefe a destra",
  "block.minecraft.banner.square_top_left.blue": "Cantón azul en xefe a destra",
  "block.minecraft.banner.square_top_left.brown": "Cantón marrón en xefe a destra",
  "block.minecraft.banner.square_top_left.cyan": "Cantón ciano en xefe a destra",
  "block.minecraft.banner.square_top_left.gray": "Cantón gris en xefe a destra",
  "block.minecraft.banner.square_top_left.green": "Cantón verde en xefe a destra",
  "block.minecraft.banner.square_top_left.light_blue": "Cantón azul claro en xefe a destra",
  "block.minecraft.banner.square_top_left.light_gray": "Cantón gris claro en xefe a destra",
  "block.minecraft.banner.square_top_left.lime": "Cantón lima en xefe a destra",
  "block.minecraft.banner.square_top_left.magenta": "Cantón maxenta en xefe a destra",
  "block.minecraft.banner.square_top_left.orange": "Cantón laranxa en xefe a destra",
  "block.minecraft.banner.square_top_left.pink": "Cantón rosa en xefe a destra",
  "block.minecraft.banner.square_top_left.purple": "Cantón púrpura en xefe a destra",
  "block.minecraft.banner.square_top_left.red": "Cantón vermello en xefe a destra",
  "block.minecraft.banner.square_top_left.white": "Cantón branco en xefe a destra",
  "block.minecraft.banner.square_top_left.yellow": "Cantón amarelo en xefe a destra",
  "block.minecraft.banner.square_top_right.black": "Cantón negro en xefe a destra",
  "block.minecraft.banner.square_top_right.blue": "Cantón azul en xefe a sinistra",
  "block.minecraft.banner.square_top_right.brown": "Cantón marrón en xefe a sinistra",
  "block.minecraft.banner.square_top_right.cyan": "Cantón ciano en xefe a sinistra",
  "block.minecraft.banner.square_top_right.gray": "Cantón gris en xefe a sinistra",
  "block.minecraft.banner.square_top_right.green": "Cantón verde en xefe a sinistra",
  "block.minecraft.banner.square_top_right.light_blue": "Cantón azul claro en xefe a sinistra",
  "block.minecraft.banner.square_top_right.light_gray": "Cantón gris claro en xefe a sinistra",
  "block.minecraft.banner.square_top_right.lime": "Cantón lima en xefe a sinistra",
  "block.minecraft.banner.square_top_right.magenta": "Cantón maxenta en xefe a sinistra",
  "block.minecraft.banner.square_top_right.orange": "Cantón laranxa en xefe a sinistra",
  "block.minecraft.banner.square_top_right.pink": "Cantón rosa en xefe a sinistra",
  "block.minecraft.banner.square_top_right.purple": "Cantón púrpura en xefe a sinistra",
  "block.minecraft.banner.square_top_right.red": "Cantón vermello en xefe a sinistra",
  "block.minecraft.banner.square_top_right.white": "Cantón branco en xefe a sinistra",
  "block.minecraft.banner.square_top_right.yellow": "Cantón amarelo en xefe a sinistra",
  "block.minecraft.banner.straight_cross.black": "Cruz negra",
  "block.minecraft.banner.straight_cross.blue": "Cruz azul",
  "block.minecraft.banner.straight_cross.brown": "Cruz marrón",
  "block.minecraft.banner.straight_cross.cyan": "Cruz ciano",
  "block.minecraft.banner.straight_cross.gray": "Cruz gris",
  "block.minecraft.banner.straight_cross.green": "Cruz verde",
  "block.minecraft.banner.straight_cross.light_blue": "Cruz azul claro",
  "block.minecraft.banner.straight_cross.light_gray": "Cruz gris claro",
  "block.minecraft.banner.straight_cross.lime": "Cruz lima",
  "block.minecraft.banner.straight_cross.magenta": "Cruz maxenta",
  "block.minecraft.banner.straight_cross.orange": "Cruz maxenta",
  "block.minecraft.banner.straight_cross.pink": "Cruz rosa",
  "block.minecraft.banner.straight_cross.purple": "Cruz púrpura",
  "block.minecraft.banner.straight_cross.red": "Cruz vermella",
  "block.minecraft.banner.straight_cross.white": "Cruz branca",
  "block.minecraft.banner.straight_cross.yellow": "Cruz amarela",
  "block.minecraft.banner.stripe_bottom.black": "Base negra",
  "block.minecraft.banner.stripe_bottom.blue": "Base azul",
  "block.minecraft.banner.stripe_bottom.brown": "Base marrón",
  "block.minecraft.banner.stripe_bottom.cyan": "Base ciano",
  "block.minecraft.banner.stripe_bottom.gray": "Base gris",
  "block.minecraft.banner.stripe_bottom.green": "Base verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Base azul claro",
  "block.minecraft.banner.stripe_bottom.light_gray": "Base gris claro",
  "block.minecraft.banner.stripe_bottom.lime": "Base lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Base maxenta",
  "block.minecraft.banner.stripe_bottom.orange": "Base laranxa",
  "block.minecraft.banner.stripe_bottom.pink": "Base rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Base púrpura",
  "block.minecraft.banner.stripe_bottom.red": "Base vermella",
  "block.minecraft.banner.stripe_bottom.white": "Base branca",
  "block.minecraft.banner.stripe_bottom.yellow": "Base amarela",
  "block.minecraft.banner.stripe_center.black": "Pau negro",
  "block.minecraft.banner.stripe_center.blue": "Pau azul",
  "block.minecraft.banner.stripe_center.brown": "Pau marrón",
  "block.minecraft.banner.stripe_center.cyan": "Pau ciano",
  "block.minecraft.banner.stripe_center.gray": "Pau gris",
  "block.minecraft.banner.stripe_center.green": "Pau verde",
  "block.minecraft.banner.stripe_center.light_blue": "Pau azul claro",
  "block.minecraft.banner.stripe_center.light_gray": "Pau gris claro",
  "block.minecraft.banner.stripe_center.lime": "Pau lima",
  "block.minecraft.banner.stripe_center.magenta": "Pau maxenta",
  "block.minecraft.banner.stripe_center.orange": "Pau laranxa",
  "block.minecraft.banner.stripe_center.pink": "Pau rosa",
  "block.minecraft.banner.stripe_center.purple": "Pau púrpura",
  "block.minecraft.banner.stripe_center.red": "Pau vermello",
  "block.minecraft.banner.stripe_center.white": "Pau branco",
  "block.minecraft.banner.stripe_center.yellow": "Pau amarelo",
  "block.minecraft.banner.stripe_downleft.black": "Banda negra a sinistra",
  "block.minecraft.banner.stripe_downleft.blue": "Banda azul a sinistra",
  "block.minecraft.banner.stripe_downleft.brown": "Banda marrón a sinistra",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda ciano a sinistra",
  "block.minecraft.banner.stripe_downleft.gray": "Banda gris a sinistra",
  "block.minecraft.banner.stripe_downleft.green": "Banda verde a sinistra",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda azul claro a sinistra",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda gris claro a sinistra",
  "block.minecraft.banner.stripe_downleft.lime": "Banda lima a sinistra",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda maxenta a sinistra",
  "block.minecraft.banner.stripe_downleft.orange": "Banda laranxa a sinistra",
  "block.minecraft.banner.stripe_downleft.pink": "Banda rosa a sinistra",
  "block.minecraft.banner.stripe_downleft.purple": "Banda púrpura a sinistra",
  "block.minecraft.banner.stripe_downleft.red": "Banda vermella a sinistra",
  "block.minecraft.banner.stripe_downleft.white": "Banda branca a sinistra",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda amarela a sinistra",
  "block.minecraft.banner.stripe_downright.black": "Banda negra",
  "block.minecraft.banner.stripe_downright.blue": "Banda azul",
  "block.minecraft.banner.stripe_downright.brown": "Banda marrón",
  "block.minecraft.banner.stripe_downright.cyan": "Banda ciano",
  "block.minecraft.banner.stripe_downright.gray": "Banda gris",
  "block.minecraft.banner.stripe_downright.green": "Banda verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda azul claro",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda gris claro",
  "block.minecraft.banner.stripe_downright.lime": "Banda lima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda maxenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda laranxa",
  "block.minecraft.banner.stripe_downright.pink": "Banda rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda púrpura",
  "block.minecraft.banner.stripe_downright.red": "Banda vermella",
  "block.minecraft.banner.stripe_downright.white": "Banda branca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda amarela",
  "block.minecraft.banner.stripe_left.black": "Pau negro a destra",
  "block.minecraft.banner.stripe_left.blue": "Pau azul a destra",
  "block.minecraft.banner.stripe_left.brown": "Pau marrón a destra",
  "block.minecraft.banner.stripe_left.cyan": "Pau ciano a destra",
  "block.minecraft.banner.stripe_left.gray": "Pau gris a destra",
  "block.minecraft.banner.stripe_left.green": "Pau verde a destra",
  "block.minecraft.banner.stripe_left.light_blue": "Pau azul claro a destra",
  "block.minecraft.banner.stripe_left.light_gray": "Pau gris claro a destra",
  "block.minecraft.banner.stripe_left.lime": "Pau lima a destra",
  "block.minecraft.banner.stripe_left.magenta": "Pau maxenta a destra",
  "block.minecraft.banner.stripe_left.orange": "Pau laranxa a destra",
  "block.minecraft.banner.stripe_left.pink": "Pau rosa a destra",
  "block.minecraft.banner.stripe_left.purple": "Pau púrpura a destra",
  "block.minecraft.banner.stripe_left.red": "Pau vermello a destra",
  "block.minecraft.banner.stripe_left.white": "Pau branco a destra",
  "block.minecraft.banner.stripe_left.yellow": "Pau amarelo a destra",
  "block.minecraft.banner.stripe_middle.black": "Fraixa negra",
  "block.minecraft.banner.stripe_middle.blue": "Faixa azul",
  "block.minecraft.banner.stripe_middle.brown": "Faixa marrón",
  "block.minecraft.banner.stripe_middle.cyan": "Faixa ciano",
  "block.minecraft.banner.stripe_middle.gray": "Faixa gris",
  "block.minecraft.banner.stripe_middle.green": "Faixa verde",
  "block.minecraft.banner.stripe_middle.light_blue": "Faixa azul claro",
  "block.minecraft.banner.stripe_middle.light_gray": "Faixa gris claro",
  "block.minecraft.banner.stripe_middle.lime": "Faixa lima",
  "block.minecraft.banner.stripe_middle.magenta": "Faixa maxenta",
  "block.minecraft.banner.stripe_middle.orange": "Faixa laranxa",
  "block.minecraft.banner.stripe_middle.pink": "Faixa rosa",
  "block.minecraft.banner.stripe_middle.purple": "Faixa púrpura",
  "block.minecraft.banner.stripe_middle.red": "Faixa vermella",
  "block.minecraft.banner.stripe_middle.white": "Faixa branca",
  "block.minecraft.banner.stripe_middle.yellow": "Faixa amarela",
  "block.minecraft.banner.stripe_right.black": "Pau negro a sinistra",
  "block.minecraft.banner.stripe_right.blue": "Pau azul a sinistra",
  "block.minecraft.banner.stripe_right.brown": "Pau marrón a sinistra",
  "block.minecraft.banner.stripe_right.cyan": "Pau ciano a sinistra",
  "block.minecraft.banner.stripe_right.gray": "Pau gris a sinistra",
  "block.minecraft.banner.stripe_right.green": "Pau verde a sinistra",
  "block.minecraft.banner.stripe_right.light_blue": "Pau azul claro a sinistra",
  "block.minecraft.banner.stripe_right.light_gray": "Pau gris claro a sinistra",
  "block.minecraft.banner.stripe_right.lime": "Pau lima a sinistra",
  "block.minecraft.banner.stripe_right.magenta": "Pau maxenta a sinistra",
  "block.minecraft.banner.stripe_right.orange": "Pau laranxa a sinistra",
  "block.minecraft.banner.stripe_right.pink": "Pau rosa a sinistra",
  "block.minecraft.banner.stripe_right.purple": "Pau púrpura a sinistra",
  "block.minecraft.banner.stripe_right.red": "Pau vermello a sinistra",
  "block.minecraft.banner.stripe_right.white": "Pau branco a sinistra",
  "block.minecraft.banner.stripe_right.yellow": "Pau amarelo a sinistra",
  "block.minecraft.banner.stripe_top.black": "Xefe negro",
  "block.minecraft.banner.stripe_top.blue": "Xefe azul",
  "block.minecraft.banner.stripe_top.brown": "Xefe marrón",
  "block.minecraft.banner.stripe_top.cyan": "Xefe ciano",
  "block.minecraft.banner.stripe_top.gray": "Xefe gris",
  "block.minecraft.banner.stripe_top.green": "Xefe verde",
  "block.minecraft.banner.stripe_top.light_blue": "Xefe azul claro",
  "block.minecraft.banner.stripe_top.light_gray": "Xefe gris claro",
  "block.minecraft.banner.stripe_top.lime": "Xefe lima",
  "block.minecraft.banner.stripe_top.magenta": "Xefe maxenta",
  "block.minecraft.banner.stripe_top.orange": "Xefe laranxa",
  "block.minecraft.banner.stripe_top.pink": "Xefe rosa",
  "block.minecraft.banner.stripe_top.purple": "Xefe púrpura",
  "block.minecraft.banner.stripe_top.red": "Xefe vermello",
  "block.minecraft.banner.stripe_top.white": "Xefe branco",
  "block.minecraft.banner.stripe_top.yellow": "Xefe amarelo",
  "block.minecraft.banner.triangle_bottom.black": "Chevrón negro",
  "block.minecraft.banner.triangle_bottom.blue": "Chevrón azul",
  "block.minecraft.banner.triangle_bottom.brown": "Chevrón marrón",
  "block.minecraft.banner.triangle_bottom.cyan": "Chevrón ciano",
  "block.minecraft.banner.triangle_bottom.gray": "Chevrón gris",
  "block.minecraft.banner.triangle_bottom.green": "Chevrón verde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Chevrón azul claro",
  "block.minecraft.banner.triangle_bottom.light_gray": "Chevrón gris claro",
  "block.minecraft.banner.triangle_bottom.lime": "Chevrón lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Chevrón maxenta",
  "block.minecraft.banner.triangle_bottom.orange": "Chevrón laranxa",
  "block.minecraft.banner.triangle_bottom.pink": "Chevrón rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Chevrón púrpura",
  "block.minecraft.banner.triangle_bottom.red": "Chevrón vermello",
  "block.minecraft.banner.triangle_bottom.white": "Chevrón branco",
  "block.minecraft.banner.triangle_bottom.yellow": "Chevrón amarelo",
  "block.minecraft.banner.triangle_top.black": "Chevrón negro invertido",
  "block.minecraft.banner.triangle_top.blue": "Chevrón azul invertido",
  "block.minecraft.banner.triangle_top.brown": "Chevrón marrón invertido",
  "block.minecraft.banner.triangle_top.cyan": "Chevrón ciano invertido",
  "block.minecraft.banner.triangle_top.gray": "Chevrón gris invertido",
  "block.minecraft.banner.triangle_top.green": "Chevrón verde invertido",
  "block.minecraft.banner.triangle_top.light_blue": "Chevrón azul claro invertido",
  "block.minecraft.banner.triangle_top.light_gray": "Chevrón gris claro invertido",
  "block.minecraft.banner.triangle_top.lime": "Chevrón lima invertido",
  "block.minecraft.banner.triangle_top.magenta": "Chevrón maxenta invertido",
  "block.minecraft.banner.triangle_top.orange": "Chevrón laranxa invertido",
  "block.minecraft.banner.triangle_top.pink": "Chevrón rosa invertido",
  "block.minecraft.banner.triangle_top.purple": "Chevrón púrpura invertido",
  "block.minecraft.banner.triangle_top.red": "Chevrón vermello invertido",
  "block.minecraft.banner.triangle_top.white": "Chevrón blanco invertido",
  "block.minecraft.banner.triangle_top.yellow": "Chevrón amarelo invertido",
  "block.minecraft.banner.triangles_bottom.black": "Base negra dentada",
  "block.minecraft.banner.triangles_bottom.blue": "Base azul dentada",
  "block.minecraft.banner.triangles_bottom.brown": "Base marrón dentada",
  "block.minecraft.banner.triangles_bottom.cyan": "Base ciano dentada",
  "block.minecraft.banner.triangles_bottom.gray": "Base gris dentada",
  "block.minecraft.banner.triangles_bottom.green": "Base verde dentada",
  "block.minecraft.banner.triangles_bottom.light_blue": "Base azul claro dentada",
  "block.minecraft.banner.triangles_bottom.light_gray": "Base gris claro dentada",
  "block.minecraft.banner.triangles_bottom.lime": "Base lima dentada",
  "block.minecraft.banner.triangles_bottom.magenta": "Base maxenta dentada",
  "block.minecraft.banner.triangles_bottom.orange": "Base laranxa dentada",
  "block.minecraft.banner.triangles_bottom.pink": "Base rosa dentada",
  "block.minecraft.banner.triangles_bottom.purple": "Base púrpura dentada",
  "block.minecraft.banner.triangles_bottom.red": "Base vermella dentada",
  "block.minecraft.banner.triangles_bottom.white": "Base branca dentada",
  "block.minecraft.banner.triangles_bottom.yellow": "Base amarela dentada",
  "block.minecraft.banner.triangles_top.black": "Xefe negro dentado",
  "block.minecraft.banner.triangles_top.blue": "Xefe azul dentado",
  "block.minecraft.banner.triangles_top.brown": "Xefe marrón dentado",
  "block.minecraft.banner.triangles_top.cyan": "Xefe ciano dentado",
  "block.minecraft.banner.triangles_top.gray": "Xefe gris dentado",
  "block.minecraft.banner.triangles_top.green": "Xefe verde dentado",
  "block.minecraft.banner.triangles_top.light_blue": "Xefe azul claro dentado",
  "block.minecraft.banner.triangles_top.light_gray": "Xefe gris claro dentado",
  "block.minecraft.banner.triangles_top.lime": "Xefe lima dentado",
  "block.minecraft.banner.triangles_top.magenta": "Xefe maxenta dentado",
  "block.minecraft.banner.triangles_top.orange": "Xefe laranxa dentado",
  "block.minecraft.banner.triangles_top.pink": "Xefe rosa dentado",
  "block.minecraft.banner.triangles_top.purple": "Xefe púrpura dentado",
  "block.minecraft.banner.triangles_top.red": "Xefe vermello dentado",
  "block.minecraft.banner.triangles_top.white": "Xefe branco dentado",
  "block.minecraft.banner.triangles_top.yellow": "Xefe amarelo dentado",
  "block.minecraft.barrel": "Bocoi",
  "block.minecraft.barrier": "Barreira",
  "block.minecraft.basalt": "Basalto",
  "block.minecraft.beacon": "Faro",
  "block.minecraft.beacon.primary": "Poder principal",
  "block.minecraft.beacon.secondary": "Poder secundario",
  "block.minecraft.bed.no_sleep": "Só podes durmir pola noite e durante as tormentas",
  "block.minecraft.bed.not_safe": "Non podes durmir agora, hai monstros preto",
  "block.minecraft.bed.obstructed": "Esta cama está obstruída",
  "block.minecraft.bed.occupied": "Esta cama está ocupada",
  "block.minecraft.bed.too_far_away": "Non podes durmir agora, a cama está moi lonxe",
  "block.minecraft.bedrock": "Pedra base",
  "block.minecraft.bee_nest": "Colmea",
  "block.minecraft.beehive": "Abellariza",
  "block.minecraft.beetroots": "Remolachas",
  "block.minecraft.bell": "Campá",
  "block.minecraft.big_dripleaf": "Planta pingueira grande",
  "block.minecraft.big_dripleaf_stem": "Talo de planta pingueira grande",
  "block.minecraft.birch_button": "Botón de bidueiro",
  "block.minecraft.birch_door": "Porta de bidueiro",
  "block.minecraft.birch_fence": "Valado de bidueiro",
  "block.minecraft.birch_fence_gate": "Cancela de bidueiro",
  "block.minecraft.birch_hanging_sign": "Letreiro colgante de bidueiro",
  "block.minecraft.birch_leaves": "Follas de bidueiro",
  "block.minecraft.birch_log": "Tronco de bidueiro",
  "block.minecraft.birch_planks": "Táboas de bidueiro",
  "block.minecraft.birch_pressure_plate": "Placa de presión de bidueiro",
  "block.minecraft.birch_sapling": "Gromo de bidueiro",
  "block.minecraft.birch_shelf": "Andel de bidueiro",
  "block.minecraft.birch_sign": "Letreiro de bidueiro",
  "block.minecraft.birch_slab": "Lastra de bidueiro",
  "block.minecraft.birch_stairs": "Escaleiras de bidueiro",
  "block.minecraft.birch_trapdoor": "Zapón de bidueiro",
  "block.minecraft.birch_wall_hanging_sign": "Letreiro colgante de bidueiro de parede",
  "block.minecraft.birch_wall_sign": "Letreiro de bidueiro de parede",
  "block.minecraft.birch_wood": "Madeira de bidueiro",
  "block.minecraft.black_banner": "Estandarte negro",
  "block.minecraft.black_bed": "Cama negra",
  "block.minecraft.black_candle": "Candea negra",
  "block.minecraft.black_candle_cake": "Torta con candea negra",
  "block.minecraft.black_carpet": "Alfombra negra",
  "block.minecraft.black_concrete": "Formigón negro",
  "block.minecraft.black_concrete_powder": "Cemento negro",
  "block.minecraft.black_glazed_terracotta": "Azulexo negro",
  "block.minecraft.black_shulker_box": "Caixa de shulker negra",
  "block.minecraft.black_stained_glass": "Vidro tinguido de negro",
  "block.minecraft.black_stained_glass_pane": "Panel de vidro tinguido de negro",
  "block.minecraft.black_terracotta": "Terracota negra",
  "block.minecraft.black_wool": "La negra",
  "block.minecraft.blackstone": "Pedra negra",
  "block.minecraft.blackstone_slab": "Lastra de pedra negra",
  "block.minecraft.blackstone_stairs": "Escaleiras de pedra negra",
  "block.minecraft.blackstone_wall": "Muro de pedra negra",
  "block.minecraft.blast_furnace": "Alto forno",
  "block.minecraft.blue_banner": "Estandarte azul",
  "block.minecraft.blue_bed": "Cama azul",
  "block.minecraft.blue_candle": "Candea azul",
  "block.minecraft.blue_candle_cake": "Torta con candea azul",
  "block.minecraft.blue_carpet": "Alfombra azul",
  "block.minecraft.blue_concrete": "Formigón azul",
  "block.minecraft.blue_concrete_powder": "Cemento azul",
  "block.minecraft.blue_glazed_terracotta": "Azulexo azul",
  "block.minecraft.blue_ice": "Xeo azul",
  "block.minecraft.blue_orchid": "Orquídea azul",
  "block.minecraft.blue_shulker_box": "Caixa de shulker azul",
  "block.minecraft.blue_stained_glass": "Vidro tinguido de azul",
  "block.minecraft.blue_stained_glass_pane": "Panel de vidro tinguido de azul",
  "block.minecraft.blue_terracotta": "Terracota azul",
  "block.minecraft.blue_wool": "La azul",
  "block.minecraft.bone_block": "Bloque de ósos",
  "block.minecraft.bookshelf": "Andel de libros",
  "block.minecraft.brain_coral": "Coral de cerebro",
  "block.minecraft.brain_coral_block": "Bloque de coral de cerebro",
  "block.minecraft.brain_coral_fan": "Gorgonia de cerebro",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia de cerebro de parede",
  "block.minecraft.brewing_stand": "Fermentador",
  "block.minecraft.brick_slab": "Lastra de ladrillos",
  "block.minecraft.brick_stairs": "Escaleiras de ladrillos",
  "block.minecraft.brick_wall": "Muro de ladrillos",
  "block.minecraft.bricks": "Ladrillos",
  "block.minecraft.brown_banner": "Estandarte marrón",
  "block.minecraft.brown_bed": "Cama marrón",
  "block.minecraft.brown_candle": "Candea marrón",
  "block.minecraft.brown_candle_cake": "Torta con candea marrón",
  "block.minecraft.brown_carpet": "Alfombra marrón",
  "block.minecraft.brown_concrete": "Formigón marrón",
  "block.minecraft.brown_concrete_powder": "Cemento marrón",
  "block.minecraft.brown_glazed_terracotta": "Azulexo marrón",
  "block.minecraft.brown_mushroom": "Cogomelo marrón",
  "block.minecraft.brown_mushroom_block": "Bloque de cogomelo marrón",
  "block.minecraft.brown_shulker_box": "Caixa de shulker marrón",
  "block.minecraft.brown_stained_glass": "Vidro tinguido de marrón",
  "block.minecraft.brown_stained_glass_pane": "Panel de vidro tinguido de marrón",
  "block.minecraft.brown_terracotta": "Terracota marrón",
  "block.minecraft.brown_wool": "La marrón",
  "block.minecraft.bubble_column": "Columna de burbullas",
  "block.minecraft.bubble_coral": "Coral de burbulla",
  "block.minecraft.bubble_coral_block": "Bloque de coral burbulla",
  "block.minecraft.bubble_coral_fan": "Gorgonia de burbulla",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia de burbulla de parede",
  "block.minecraft.budding_amethyst": "Cristalizador de ametista",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Cacto",
  "block.minecraft.cactus_flower": "Flor de cacto",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de sculk calibrado",
  "block.minecraft.campfire": "Cacharela",
  "block.minecraft.candle": "Candea",
  "block.minecraft.candle_cake": "Torta con candea",
  "block.minecraft.carrots": "Cenorias",
  "block.minecraft.cartography_table": "Mesa de cartografía",
  "block.minecraft.carved_pumpkin": "Cabaza esculpida",
  "block.minecraft.cauldron": "Caldeiro",
  "block.minecraft.cave_air": "Ar de cova",
  "block.minecraft.cave_vines": "Trepadeiras de cova",
  "block.minecraft.cave_vines_plant": "Planta de trepadeiras de cova",
  "block.minecraft.chain": "Cadea de ferro",
  "block.minecraft.chain_command_block": "Bloque de comandos en cadea",
  "block.minecraft.cherry_button": "Botón de cerdeira",
  "block.minecraft.cherry_door": "Porta de cerdeira",
  "block.minecraft.cherry_fence": "Valado de cerdeira",
  "block.minecraft.cherry_fence_gate": "Cancela de cerdeira",
  "block.minecraft.cherry_hanging_sign": "Letreiro colgante de cerdeira",
  "block.minecraft.cherry_leaves": "Follas de cerdeira",
  "block.minecraft.cherry_log": "Tronco de cerdeira",
  "block.minecraft.cherry_planks": "Táboas de cerdeira",
  "block.minecraft.cherry_pressure_plate": "Placa de presión de cerdeira",
  "block.minecraft.cherry_sapling": "Gromo de cerdeira",
  "block.minecraft.cherry_shelf": "Andel de cerdeira",
  "block.minecraft.cherry_sign": "Letreiro de cerdeira",
  "block.minecraft.cherry_slab": "Lastra de cerdeira",
  "block.minecraft.cherry_stairs": "Escaleiras de cerdeira",
  "block.minecraft.cherry_trapdoor": "Zapón de cerdeira",
  "block.minecraft.cherry_wall_hanging_sign": "Letreiro colgante de cerdeira de parede",
  "block.minecraft.cherry_wall_sign": "Letreiro colgante de cerdeira de parede",
  "block.minecraft.cherry_wood": "Madeira de cerdeira",
  "block.minecraft.chest": "Cofre",
  "block.minecraft.chipped_anvil": "Engra danada",
  "block.minecraft.chiseled_bookshelf": "Andel de libros cicelado",
  "block.minecraft.chiseled_copper": "Cobre cicelado",
  "block.minecraft.chiseled_deepslate": "Lousa profunda cicelada",
  "block.minecraft.chiseled_nether_bricks": "Ladrillos do Nether cicelados",
  "block.minecraft.chiseled_polished_blackstone": "Pedra negra puída cicelada",
  "block.minecraft.chiseled_quartz_block": "Bloque de cuarzo cicelado",
  "block.minecraft.chiseled_red_sandstone": "Arenito vermello cicelado",
  "block.minecraft.chiseled_resin_bricks": "Ladrillos de recina cicelada",
  "block.minecraft.chiseled_sandstone": "Arenito cicelado",
  "block.minecraft.chiseled_stone_bricks": "Ladrillos de pedra cicelados",
  "block.minecraft.chiseled_tuff": "Tufo cicelado",
  "block.minecraft.chiseled_tuff_bricks": "Ladrillos de tufo cicelado",
  "block.minecraft.chorus_flower": "Flor coral",
  "block.minecraft.chorus_plant": "Planta coral",
  "block.minecraft.clay": "Arxila",
  "block.minecraft.closed_eyeblossom": "Fitamel pechada",
  "block.minecraft.coal_block": "Bloque de carbón",
  "block.minecraft.coal_ore": "Mineral de carbón",
  "block.minecraft.coarse_dirt": "Terra árida",
  "block.minecraft.cobbled_deepslate": "Pedras de lousa profunda",
  "block.minecraft.cobbled_deepslate_slab": "Lastra de pedras de lousa profunda",
  "block.minecraft.cobbled_deepslate_stairs": "Escaleiras de pedras de lousa profunda",
  "block.minecraft.cobbled_deepslate_wall": "Muro de pedras de lousa profunda",
  "block.minecraft.cobblestone": "Pedra",
  "block.minecraft.cobblestone_slab": "Lastra de pedra",
  "block.minecraft.cobblestone_stairs": "Escaleiras de pedra",
  "block.minecraft.cobblestone_wall": "Muro de pedra",
  "block.minecraft.cobweb": "Arañeira",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Bloque de comandos",
  "block.minecraft.comparator": "Comparador de redstone",
  "block.minecraft.composter": "Composteiro",
  "block.minecraft.conduit": "Canalizador",
  "block.minecraft.copper_bars": "Barrotes de cobre",
  "block.minecraft.copper_block": "Bloque de cobre",
  "block.minecraft.copper_bulb": "Lámpada de cobre",
  "block.minecraft.copper_chain": "Cadea de cobre",
  "block.minecraft.copper_chest": "Cofre de cobre",
  "block.minecraft.copper_door": "Porta de cobre",
  "block.minecraft.copper_golem_statue": "Estatua de gólem de cobre",
  "block.minecraft.copper_grate": "Reixa de cobre",
  "block.minecraft.copper_lantern": "Lanterna de cobre",
  "block.minecraft.copper_ore": "Mineral de cobre",
  "block.minecraft.copper_torch": "Facho de cobre",
  "block.minecraft.copper_trapdoor": "Zapón de cobre",
  "block.minecraft.copper_wall_torch": "Facho de cobre de parede",
  "block.minecraft.cornflower": "Cardafuso",
  "block.minecraft.cracked_deepslate_bricks": "Ladrillos de lousa profunda rachados",
  "block.minecraft.cracked_deepslate_tiles": "Baldosas de lousa profunda rachadas",
  "block.minecraft.cracked_nether_bricks": "Ladrillos do Nether rachados",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ladrillos de pedra negra puída rachados",
  "block.minecraft.cracked_stone_bricks": "Ladrillos de pedra rachados",
  "block.minecraft.crafter": "Fabricador",
  "block.minecraft.crafting_table": "Mesa de fabricación",
  "block.minecraft.creaking_heart": "Corazón crepitante",
  "block.minecraft.creeper_head": "Cabeza de creeper",
  "block.minecraft.creeper_wall_head": "Cabeza de creeper de parede",
  "block.minecraft.crimson_button": "Botón carmesí",
  "block.minecraft.crimson_door": "Porta carmesí",
  "block.minecraft.crimson_fence": "Valado carmesí",
  "block.minecraft.crimson_fence_gate": "Cancela carmesí",
  "block.minecraft.crimson_fungus": "Fungo carmesí",
  "block.minecraft.crimson_hanging_sign": "Letreiro colgante carmesí",
  "block.minecraft.crimson_hyphae": "Hifas carmesís",
  "block.minecraft.crimson_nylium": "Nicelio carmesí",
  "block.minecraft.crimson_planks": "Táboas carmesí",
  "block.minecraft.crimson_pressure_plate": "Placa de presión carmesí",
  "block.minecraft.crimson_roots": "Raíces carmesís",
  "block.minecraft.crimson_shelf": "Andel carmesí",
  "block.minecraft.crimson_sign": "Letreiro carmesí",
  "block.minecraft.crimson_slab": "Lastra carmesí",
  "block.minecraft.crimson_stairs": "Escaleiras carmesí",
  "block.minecraft.crimson_stem": "Talo carmesí",
  "block.minecraft.crimson_trapdoor": "Zapón carmesí",
  "block.minecraft.crimson_wall_hanging_sign": "Letreiro colgante carmesí de parede",
  "block.minecraft.crimson_wall_sign": "Letreiro carmesí de parede",
  "block.minecraft.crying_obsidian": "Obsidiana chorona",
  "block.minecraft.cut_copper": "Cobre cortado",
  "block.minecraft.cut_copper_slab": "Lastra de cobre cortado",
  "block.minecraft.cut_copper_stairs": "Escaleiras de cobre cortado",
  "block.minecraft.cut_red_sandstone": "Arenito vermello cortado",
  "block.minecraft.cut_red_sandstone_slab": "Lastra de arenito vermello cortado",
  "block.minecraft.cut_sandstone": "Arenito cortado",
  "block.minecraft.cut_sandstone_slab": "Lastra de arenito cortado",
  "block.minecraft.cyan_banner": "Estandarte ciano",
  "block.minecraft.cyan_bed": "Cama ciano",
  "block.minecraft.cyan_candle": "Candea ciano",
  "block.minecraft.cyan_candle_cake": "Torta con candea ciano",
  "block.minecraft.cyan_carpet": "Alfombra ciano",
  "block.minecraft.cyan_concrete": "Formigón ciano",
  "block.minecraft.cyan_concrete_powder": "Cemento ciano",
  "block.minecraft.cyan_glazed_terracotta": "Azulexo ciano",
  "block.minecraft.cyan_shulker_box": "Caixa de shulker ciano",
  "block.minecraft.cyan_stained_glass": "Vidro tinguido de ciano",
  "block.minecraft.cyan_stained_glass_pane": "Panel de vidro tinguido de ciano",
  "block.minecraft.cyan_terracotta": "Terracota ciano",
  "block.minecraft.cyan_wool": "La ciano",
  "block.minecraft.damaged_anvil": "Engra moi danada",
  "block.minecraft.dandelion": "Dente de león",
  "block.minecraft.dark_oak_button": "Botón de carballo escuro",
  "block.minecraft.dark_oak_door": "Porta de carballo escuro",
  "block.minecraft.dark_oak_fence": "Valado de carballo escuro",
  "block.minecraft.dark_oak_fence_gate": "Cancela de carballo escuro",
  "block.minecraft.dark_oak_hanging_sign": "Letreiro colgante de carballo escuro",
  "block.minecraft.dark_oak_leaves": "Follas de carballo escuro",
  "block.minecraft.dark_oak_log": "Tronco de carballo escuro",
  "block.minecraft.dark_oak_planks": "Táboas de carballo escuro",
  "block.minecraft.dark_oak_pressure_plate": "Placa de presión de carballo escuro",
  "block.minecraft.dark_oak_sapling": "Gromo de carballo escuro",
  "block.minecraft.dark_oak_shelf": "Andel de carballo escuro",
  "block.minecraft.dark_oak_sign": "Letreiro de carballo escuro",
  "block.minecraft.dark_oak_slab": "Lastra de carballo escuro",
  "block.minecraft.dark_oak_stairs": "Escaleiras de carballo escuro",
  "block.minecraft.dark_oak_trapdoor": "Zapón de carballo escuro",
  "block.minecraft.dark_oak_wall_hanging_sign": "Letreiro colgante de carballo escuro de parede",
  "block.minecraft.dark_oak_wall_sign": "Letreiro de carballo escuro de parede",
  "block.minecraft.dark_oak_wood": "Madeira de carballo escuro",
  "block.minecraft.dark_prismarine": "Prismariña escura",
  "block.minecraft.dark_prismarine_slab": "Lastra de prismariña escura",
  "block.minecraft.dark_prismarine_stairs": "Escaleiras de prismariña escura",
  "block.minecraft.daylight_detector": "Sensor de luz solar",
  "block.minecraft.dead_brain_coral": "Coral de cerebro morto",
  "block.minecraft.dead_brain_coral_block": "Bloque de coral de cerebro morto",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia de cerebro morta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia de cerebro morta de parede",
  "block.minecraft.dead_bubble_coral": "Coral de burbulla morto",
  "block.minecraft.dead_bubble_coral_block": "Bloque de coral de burbulla morto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia de burbulla morta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia de burbulla morta de parede",
  "block.minecraft.dead_bush": "Arbusto morto",
  "block.minecraft.dead_fire_coral": "Coral de lume morto",
  "block.minecraft.dead_fire_coral_block": "Bloque de coral de lume morto",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia de lume morta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia de lume morta de parede",
  "block.minecraft.dead_horn_coral": "Coral de cornos morto",
  "block.minecraft.dead_horn_coral_block": "Bloque de coral de corno morto",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia de corno morta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia de corno morta de parede",
  "block.minecraft.dead_tube_coral": "Coral de tubo morto",
  "block.minecraft.dead_tube_coral_block": "Bloque de coral de tubo morto",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia de tubo morta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia tubular morta de parede",
  "block.minecraft.decorated_pot": "Tarro decorado",
  "block.minecraft.deepslate": "Lousa profunda",
  "block.minecraft.deepslate_brick_slab": "Lastra de ladrillos de lousa profunda",
  "block.minecraft.deepslate_brick_stairs": "Escaleiras de ladrillos de lousa profunda",
  "block.minecraft.deepslate_brick_wall": "Muro de ladrillos de lousa profunda",
  "block.minecraft.deepslate_bricks": "Ladrillos de lousa profunda",
  "block.minecraft.deepslate_coal_ore": "Mineral de carbón de lousa profunda",
  "block.minecraft.deepslate_copper_ore": "Mineral de cobre de lousa profunda",
  "block.minecraft.deepslate_diamond_ore": "Mineral de diamante de lousa profunda",
  "block.minecraft.deepslate_emerald_ore": "Mineral de esmeralda de lousa profunda",
  "block.minecraft.deepslate_gold_ore": "Mineral de ouro de lousa profunda",
  "block.minecraft.deepslate_iron_ore": "Mineral de ferro de lousa profunda",
  "block.minecraft.deepslate_lapis_ore": "Mineral de lapislázuli de lousa profunda",
  "block.minecraft.deepslate_redstone_ore": "Mineral de redstone de lousa profunda",
  "block.minecraft.deepslate_tile_slab": "Lastra de baldosas de lousa profunda",
  "block.minecraft.deepslate_tile_stairs": "Escaleiras de baldosas de lousa profunda",
  "block.minecraft.deepslate_tile_wall": "Muro de baldosas de lousa profunda",
  "block.minecraft.deepslate_tiles": "Baldosas de lousa profunda",
  "block.minecraft.detector_rail": "Raíl detector",
  "block.minecraft.diamond_block": "Bloque de diamante",
  "block.minecraft.diamond_ore": "Mineral de diamante",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Lastra de diorita",
  "block.minecraft.diorite_stairs": "Escaleiras de diorita",
  "block.minecraft.diorite_wall": "Muro de diorita",
  "block.minecraft.dirt": "Terra",
  "block.minecraft.dirt_path": "Camiño de terra",
  "block.minecraft.dispenser": "Dispensador",
  "block.minecraft.dragon_egg": "Ovo de dragón",
  "block.minecraft.dragon_head": "Cabeza de dragón",
  "block.minecraft.dragon_wall_head": "Cabeza de dragón de parede",
  "block.minecraft.dried_ghast": "Ghast seco",
  "block.minecraft.dried_kelp_block": "Bloque de alga seca",
  "block.minecraft.dripstone_block": "Bloque de espeleotema",
  "block.minecraft.dropper": "Lanzador",
  "block.minecraft.emerald_block": "Bloque de esmeralda",
  "block.minecraft.emerald_ore": "Mineral de esmeralda",
  "block.minecraft.enchanting_table": "Mesa de encantamentos",
  "block.minecraft.end_gateway": "Entrada do End",
  "block.minecraft.end_portal": "Portal do End",
  "block.minecraft.end_portal_frame": "Marco do portal do End",
  "block.minecraft.end_rod": "Vara do End",
  "block.minecraft.end_stone": "Pedra do End",
  "block.minecraft.end_stone_brick_slab": "Lastra de ladrillos de pedra do End",
  "block.minecraft.end_stone_brick_stairs": "Escaleiras de ladrillos de pedra do End",
  "block.minecraft.end_stone_brick_wall": "Muro de ladrillos de pedra do End",
  "block.minecraft.end_stone_bricks": "Ladrillos de pedra do End",
  "block.minecraft.ender_chest": "Cofre do Ender",
  "block.minecraft.exposed_chiseled_copper": "Cobre cicelado exposto",
  "block.minecraft.exposed_copper": "Cobre exposto",
  "block.minecraft.exposed_copper_bars": "Barrotes de cobre exposto",
  "block.minecraft.exposed_copper_bulb": "Lámpada de cobre exposto",
  "block.minecraft.exposed_copper_chain": "Cadea de cobre exposto",
  "block.minecraft.exposed_copper_chest": "Cofre de cobre exposto",
  "block.minecraft.exposed_copper_door": "Porta de cobre exposto",
  "block.minecraft.exposed_copper_golem_statue": "Estatua de gólem de cobre exposto",
  "block.minecraft.exposed_copper_grate": "Reixa de cobre exposto",
  "block.minecraft.exposed_copper_lantern": "Lanterna de cobre exposto",
  "block.minecraft.exposed_copper_trapdoor": "Zapón de cobre exposto",
  "block.minecraft.exposed_cut_copper": "Cobre cortado exposto",
  "block.minecraft.exposed_cut_copper_slab": "Lastra de cobre cortado exposto",
  "block.minecraft.exposed_cut_copper_stairs": "Escaleiras de cobre cortado exposto",
  "block.minecraft.exposed_lightning_rod": "Pararraios exposto",
  "block.minecraft.farmland": "Terra de cultivo",
  "block.minecraft.fern": "Fento",
  "block.minecraft.fire": "Lume",
  "block.minecraft.fire_coral": "Coral de lume",
  "block.minecraft.fire_coral_block": "Bloque de coral de lume",
  "block.minecraft.fire_coral_fan": "Gorgonia de lume",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia de lume de parede",
  "block.minecraft.firefly_bush": "Arbusto de vagalumes",
  "block.minecraft.fletching_table": "Mesa de frechas",
  "block.minecraft.flower_pot": "Testo",
  "block.minecraft.flowering_azalea": "Azalea en flor",
  "block.minecraft.flowering_azalea_leaves": "Follas de azaleza florecida",
  "block.minecraft.frogspawn": "Ovos de ra",
  "block.minecraft.frosted_ice": "Carouxo",
  "block.minecraft.furnace": "Forno",
  "block.minecraft.gilded_blackstone": "Pedra negra dourada",
  "block.minecraft.glass": "Vidro",
  "block.minecraft.glass_pane": "Panel de vidro",
  "block.minecraft.glow_lichen": "Lique brillante",
  "block.minecraft.glowstone": "Pedra luminosa",
  "block.minecraft.gold_block": "Bloque de ouro",
  "block.minecraft.gold_ore": "Mineral de ouro",
  "block.minecraft.golden_dandelion": "Dente de león dourado",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Lastra de granito",
  "block.minecraft.granite_stairs": "Escaleiras de granito",
  "block.minecraft.granite_wall": "Muro de granito",
  "block.minecraft.grass": "Herba",
  "block.minecraft.grass_block": "Bloque de herba",
  "block.minecraft.gravel": "Cascallo",
  "block.minecraft.gray_banner": "Estandarte gris",
  "block.minecraft.gray_bed": "Cama gris",
  "block.minecraft.gray_candle": "Candea gris",
  "block.minecraft.gray_candle_cake": "Torta con candea gris",
  "block.minecraft.gray_carpet": "Alfombra gris",
  "block.minecraft.gray_concrete": "Formigón gris",
  "block.minecraft.gray_concrete_powder": "Cemento gris",
  "block.minecraft.gray_glazed_terracotta": "Azulexo gris",
  "block.minecraft.gray_shulker_box": "Caixa de shulker gris",
  "block.minecraft.gray_stained_glass": "Vidro tinguido de gris",
  "block.minecraft.gray_stained_glass_pane": "Panel de vidro tinguido de gris",
  "block.minecraft.gray_terracotta": "Terracota gris",
  "block.minecraft.gray_wool": "La gris",
  "block.minecraft.green_banner": "Estandarte verde",
  "block.minecraft.green_bed": "Cama verde",
  "block.minecraft.green_candle": "Candea verde",
  "block.minecraft.green_candle_cake": "Torta con candea verde",
  "block.minecraft.green_carpet": "Alfombra verde",
  "block.minecraft.green_concrete": "Formigón verde",
  "block.minecraft.green_concrete_powder": "Cemento verde",
  "block.minecraft.green_glazed_terracotta": "Azulexo verde",
  "block.minecraft.green_shulker_box": "Caixa de shulker verde",
  "block.minecraft.green_stained_glass": "Vidro tinguido de verde",
  "block.minecraft.green_stained_glass_pane": "Panel de vidro tinguido de verde",
  "block.minecraft.green_terracotta": "Terracota verde",
  "block.minecraft.green_wool": "La verde",
  "block.minecraft.grindstone": "Pedra de amolar",
  "block.minecraft.hanging_roots": "Raíces penduradas",
  "block.minecraft.hay_block": "Bala de palla",
  "block.minecraft.heavy_core": "Núcleo pesado",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de presión para peso elevado",
  "block.minecraft.honey_block": "Bloque de mel",
  "block.minecraft.honeycomb_block": "Bloque de favo",
  "block.minecraft.hopper": "Funil",
  "block.minecraft.horn_coral": "Coral de corno",
  "block.minecraft.horn_coral_block": "Bloque de coral de corno",
  "block.minecraft.horn_coral_fan": "Gorgonia de corno",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia de corno de parede",
  "block.minecraft.ice": "Xeo",
  "block.minecraft.infested_chiseled_stone_bricks": "Ladrillos de pedra cicelada infestados",
  "block.minecraft.infested_cobblestone": "Pedra infestada",
  "block.minecraft.infested_cracked_stone_bricks": "Ladrillos de pedra rachados infestados",
  "block.minecraft.infested_deepslate": "Lousa profunda infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Ladrillos de pedra musgosa infestados",
  "block.minecraft.infested_stone": "Rocha infestada",
  "block.minecraft.infested_stone_bricks": "Ladrillos de pedra infestados",
  "block.minecraft.iron_bars": "Barrotes de ferro",
  "block.minecraft.iron_block": "Bloque de ferro",
  "block.minecraft.iron_chain": "Cadea de ferro",
  "block.minecraft.iron_door": "Porta de ferro",
  "block.minecraft.iron_ore": "Mineral de ferro",
  "block.minecraft.iron_trapdoor": "Zapón de ferro",
  "block.minecraft.jack_o_lantern": "Cabaza de Samaín",
  "block.minecraft.jigsaw": "Bloque de crebacabezas",
  "block.minecraft.jukebox": "Tocadiscos",
  "block.minecraft.jungle_button": "Botón de selva",
  "block.minecraft.jungle_door": "Porta de selva",
  "block.minecraft.jungle_fence": "Valado de selva",
  "block.minecraft.jungle_fence_gate": "Cancela de selva",
  "block.minecraft.jungle_hanging_sign": "Letreiro colgante de selva",
  "block.minecraft.jungle_leaves": "Follas de selva",
  "block.minecraft.jungle_log": "Tronco de selva",
  "block.minecraft.jungle_planks": "Táboas de selva",
  "block.minecraft.jungle_pressure_plate": "Placa de presión de selva",
  "block.minecraft.jungle_sapling": "Gromo de selva",
  "block.minecraft.jungle_shelf": "Andel de selva",
  "block.minecraft.jungle_sign": "Letreiro de selva",
  "block.minecraft.jungle_slab": "Lastra de selva",
  "block.minecraft.jungle_stairs": "Escaleiras de selva",
  "block.minecraft.jungle_trapdoor": "Zapón de selva",
  "block.minecraft.jungle_wall_hanging_sign": "Letreiro colgante de selva de parede",
  "block.minecraft.jungle_wall_sign": "Letreiro de selva de parede",
  "block.minecraft.jungle_wood": "Madeira de selva",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Talo de alga",
  "block.minecraft.ladder": "Escada",
  "block.minecraft.lantern": "Lanterna",
  "block.minecraft.lapis_block": "Bloque de lapislázuli",
  "block.minecraft.lapis_ore": "Mineral de lapislázuli",
  "block.minecraft.large_amethyst_bud": "Gromo de ametista grande",
  "block.minecraft.large_fern": "Fento grande",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Caldeiro de lava",
  "block.minecraft.leaf_litter": "Follas secas",
  "block.minecraft.lectern": "Atril",
  "block.minecraft.lever": "Panca",
  "block.minecraft.light": "Luz",
  "block.minecraft.light_blue_banner": "Estandarte azul claro",
  "block.minecraft.light_blue_bed": "Cama azul claro",
  "block.minecraft.light_blue_candle": "Candea azul claro",
  "block.minecraft.light_blue_candle_cake": "Torta con candea azul claro",
  "block.minecraft.light_blue_carpet": "Alfombra azul claro",
  "block.minecraft.light_blue_concrete": "Formigón azul claro",
  "block.minecraft.light_blue_concrete_powder": "Cemento azul claro",
  "block.minecraft.light_blue_glazed_terracotta": "Azulexo azul claro",
  "block.minecraft.light_blue_shulker_box": "Caixa de shulker azul claro",
  "block.minecraft.light_blue_stained_glass": "Vidro tinguido de azul claro",
  "block.minecraft.light_blue_stained_glass_pane": "Panel de vidro tinguido de azul claro",
  "block.minecraft.light_blue_terracotta": "Terracota azul claro",
  "block.minecraft.light_blue_wool": "La azul claro",
  "block.minecraft.light_gray_banner": "Estandarte gris claro",
  "block.minecraft.light_gray_bed": "Cama gris claro",
  "block.minecraft.light_gray_candle": "Candea gris claro",
  "block.minecraft.light_gray_candle_cake": "Torta con candea gris claro",
  "block.minecraft.light_gray_carpet": "Alfombra gris claro",
  "block.minecraft.light_gray_concrete": "Formigón gris claro",
  "block.minecraft.light_gray_concrete_powder": "Cemento gris claro",
  "block.minecraft.light_gray_glazed_terracotta": "Azulexo gris claro",
  "block.minecraft.light_gray_shulker_box": "Caixa de shulker gris claro",
  "block.minecraft.light_gray_stained_glass": "Vidro tinguido de gris claro",
  "block.minecraft.light_gray_stained_glass_pane": "Panel de vidro tinguido de gris claro",
  "block.minecraft.light_gray_terracotta": "Terracota gris claro",
  "block.minecraft.light_gray_wool": "La gris claro",
  "block.minecraft.light_weighted_pressure_plate": "Placa de presión para peso lixeiro",
  "block.minecraft.lightning_rod": "Pararraios",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Lirio do val",
  "block.minecraft.lily_pad": "Ninfea",
  "block.minecraft.lime_banner": "Estandarte lima",
  "block.minecraft.lime_bed": "Cama lima",
  "block.minecraft.lime_candle": "Candea lima",
  "block.minecraft.lime_candle_cake": "Torta con candea lima",
  "block.minecraft.lime_carpet": "Alfombra lima",
  "block.minecraft.lime_concrete": "Formigón lima",
  "block.minecraft.lime_concrete_powder": "Cemento lima",
  "block.minecraft.lime_glazed_terracotta": "Azulexo lima",
  "block.minecraft.lime_shulker_box": "Caixa de shulker lima",
  "block.minecraft.lime_stained_glass": "Vidro tinguido de lima",
  "block.minecraft.lime_stained_glass_pane": "Panel de vidro tinguido de lima",
  "block.minecraft.lime_terracotta": "Terracota lima",
  "block.minecraft.lime_wool": "La lima",
  "block.minecraft.lodestone": "Magnetita",
  "block.minecraft.loom": "Tear",
  "block.minecraft.magenta_banner": "Estandarte maxenta",
  "block.minecraft.magenta_bed": "Cama maxenta",
  "block.minecraft.magenta_candle": "Candea maxenta",
  "block.minecraft.magenta_candle_cake": "Torta con candea maxenta",
  "block.minecraft.magenta_carpet": "Alfombra maxenta",
  "block.minecraft.magenta_concrete": "Formigón maxenta",
  "block.minecraft.magenta_concrete_powder": "Cemento maxenta",
  "block.minecraft.magenta_glazed_terracotta": "Azulexo maxenta",
  "block.minecraft.magenta_shulker_box": "Caixa de shulker maxenta",
  "block.minecraft.magenta_stained_glass": "Vidro tinguido de maxenta",
  "block.minecraft.magenta_stained_glass_pane": "Panel de vidro tinguido de maxenta",
  "block.minecraft.magenta_terracotta": "Terracota maxenta",
  "block.minecraft.magenta_wool": "La maxenta",
  "block.minecraft.magma_block": "Bloque de magma",
  "block.minecraft.mangrove_button": "Botón de mangleiro",
  "block.minecraft.mangrove_door": "Porta de mangleiro",
  "block.minecraft.mangrove_fence": "Valado de mangleiro",
  "block.minecraft.mangrove_fence_gate": "Cancela de mangleiro",
  "block.minecraft.mangrove_hanging_sign": "Letreiro colgante de mangleiro",
  "block.minecraft.mangrove_leaves": "Follas de mangleiro",
  "block.minecraft.mangrove_log": "Tronco de mangleiro",
  "block.minecraft.mangrove_planks": "Táboas de mangleiro",
  "block.minecraft.mangrove_pressure_plate": "Placa de presión de mangleiro",
  "block.minecraft.mangrove_propagule": "Propágulo de mangleiro",
  "block.minecraft.mangrove_roots": "Raíces de mangleiro",
  "block.minecraft.mangrove_shelf": "Andel de mangleiro",
  "block.minecraft.mangrove_sign": "Letreiro de mangleiro",
  "block.minecraft.mangrove_slab": "Lastra de mangleiro",
  "block.minecraft.mangrove_stairs": "Escaleiras de mangleiro",
  "block.minecraft.mangrove_trapdoor": "Zapón de mangleiro",
  "block.minecraft.mangrove_wall_hanging_sign": "Letreiro colgante de mangleiro de parede",
  "block.minecraft.mangrove_wall_sign": "Letreiro de mangleiro de parede",
  "block.minecraft.mangrove_wood": "Madeira de mangleiro",
  "block.minecraft.medium_amethyst_bud": "Gromo de ametista mediano",
  "block.minecraft.melon": "Sandía",
  "block.minecraft.melon_stem": "Talo de sandía",
  "block.minecraft.moss_block": "Bloque de carriza",
  "block.minecraft.moss_carpet": "Alfombra de carriza",
  "block.minecraft.mossy_cobblestone": "Pedra musgosa",
  "block.minecraft.mossy_cobblestone_slab": "Lastra de pedra musgosa",
  "block.minecraft.mossy_cobblestone_stairs": "Escaleiras de pedra musgosa",
  "block.minecraft.mossy_cobblestone_wall": "Muro de pedra musgosa",
  "block.minecraft.mossy_stone_brick_slab": "Lastra de ladrillos de pedra musgosa",
  "block.minecraft.mossy_stone_brick_stairs": "Escaleiras de ladrillos de pedra musgosa",
  "block.minecraft.mossy_stone_brick_wall": "Muro de ladrillos de pedra musgosa",
  "block.minecraft.mossy_stone_bricks": "Ladrillos de pedra musgosa",
  "block.minecraft.moving_piston": "Pistón en movemento",
  "block.minecraft.mud": "Lama",
  "block.minecraft.mud_brick_slab": "Lastra de ladrillos de lama",
  "block.minecraft.mud_brick_stairs": "Escaleiras de ladrillos de lama",
  "block.minecraft.mud_brick_wall": "Muro de ladrillos de lama",
  "block.minecraft.mud_bricks": "Ladrillos de lama",
  "block.minecraft.muddy_mangrove_roots": "Raíces de mangleiro enlamadas",
  "block.minecraft.mushroom_stem": "Pé de cogomelo",
  "block.minecraft.mycelium": "Micelio",
  "block.minecraft.nether_brick_fence": "Valado de ladrillos do Nether",
  "block.minecraft.nether_brick_slab": "Lastra de ladrillos do Nether",
  "block.minecraft.nether_brick_stairs": "Escaleiras de ladrillos do Nether",
  "block.minecraft.nether_brick_wall": "Muro de ladrillos do Nether",
  "block.minecraft.nether_bricks": "Ladrillos do Nether",
  "block.minecraft.nether_gold_ore": "Mineral de ouro do Nether",
  "block.minecraft.nether_portal": "Portal do Nether",
  "block.minecraft.nether_quartz_ore": "Mineral de cuarzo do Nether",
  "block.minecraft.nether_sprouts": "Gromos do Nether",
  "block.minecraft.nether_wart": "Espulla do Nether",
  "block.minecraft.nether_wart_block": "Bloque de espullas do Nether",
  "block.minecraft.netherite_block": "Bloque de netherita",
  "block.minecraft.netherrack": "Pedra do Nether",
  "block.minecraft.note_block": "Bloque musical",
  "block.minecraft.oak_button": "Botón de carballo",
  "block.minecraft.oak_door": "Porta de carballo",
  "block.minecraft.oak_fence": "Valado de carballo",
  "block.minecraft.oak_fence_gate": "Cancela de carballo",
  "block.minecraft.oak_hanging_sign": "Letreiro colgante de carballo",
  "block.minecraft.oak_leaves": "Follas de carballo",
  "block.minecraft.oak_log": "Tronco de carballo",
  "block.minecraft.oak_planks": "Táboas de carballo",
  "block.minecraft.oak_pressure_plate": "Placa de presión de carballo",
  "block.minecraft.oak_sapling": "Gromo de carballo",
  "block.minecraft.oak_shelf": "Andel de carballo",
  "block.minecraft.oak_sign": "Letreiro de carballo",
  "block.minecraft.oak_slab": "Lastra de carballo",
  "block.minecraft.oak_stairs": "Escaleiras de carballo",
  "block.minecraft.oak_trapdoor": "Zapón de carballo",
  "block.minecraft.oak_wall_hanging_sign": "Letreiro colgante de carballo de parede",
  "block.minecraft.oak_wall_sign": "Letreiro de carballo de parede",
  "block.minecraft.oak_wood": "Madeira de carballo",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Anfibrillo ocre",
  "block.minecraft.ominous_banner": "Estandarte sinistro",
  "block.minecraft.open_eyeblossom": "Fitamel aberta",
  "block.minecraft.orange_banner": "Estandarte laranxa",
  "block.minecraft.orange_bed": "Cama laranxa",
  "block.minecraft.orange_candle": "Candea laranxa",
  "block.minecraft.orange_candle_cake": "Torta con candea laranxa",
  "block.minecraft.orange_carpet": "Alfombra laranxa",
  "block.minecraft.orange_concrete": "Formigón laranxa",
  "block.minecraft.orange_concrete_powder": "Cemento laranxa",
  "block.minecraft.orange_glazed_terracotta": "Azulexo laranxa",
  "block.minecraft.orange_shulker_box": "Caixa de shulker laranxa",
  "block.minecraft.orange_stained_glass": "Vidro tinguido de laranxa",
  "block.minecraft.orange_stained_glass_pane": "Panel de vidro tinguido de laranxa",
  "block.minecraft.orange_terracotta": "Terracota laranxa",
  "block.minecraft.orange_tulip": "Tulipán laranxa",
  "block.minecraft.orange_wool": "La laranxa",
  "block.minecraft.oxeye_daisy": "Margarida",
  "block.minecraft.oxidized_chiseled_copper": "Cobre cicelado oxidado",
  "block.minecraft.oxidized_copper": "Cobre oxidado",
  "block.minecraft.oxidized_copper_bars": "Barrotes de cobre oxidado",
  "block.minecraft.oxidized_copper_bulb": "Lámpada de cobre oxidado",
  "block.minecraft.oxidized_copper_chain": "Cadea de cobre oxidado",
  "block.minecraft.oxidized_copper_chest": "Cofre de cobre oxidado",
  "block.minecraft.oxidized_copper_door": "Porta de cobre oxidado",
  "block.minecraft.oxidized_copper_golem_statue": "Estatua de gólem de cobre oxidada",
  "block.minecraft.oxidized_copper_grate": "Reixa de cobre oxidado",
  "block.minecraft.oxidized_copper_lantern": "Lanterna de cobre oxidado",
  "block.minecraft.oxidized_copper_trapdoor": "Zapón de cobre oxidado",
  "block.minecraft.oxidized_cut_copper": "Cobre cortado oxidado",
  "block.minecraft.oxidized_cut_copper_slab": "Lastra de cobre cortado oxidado",
  "block.minecraft.oxidized_cut_copper_stairs": "Escaleiras de cobre cortado oxidado",
  "block.minecraft.oxidized_lightning_rod": "Pararraios oxidado",
  "block.minecraft.packed_ice": "Xeo compactado",
  "block.minecraft.packed_mud": "Lama compactada",
  "block.minecraft.pale_hanging_moss": "Enredadeiras de musgo esbrancuxado",
  "block.minecraft.pale_moss_block": "Bloque de musgo esbrancuxado",
  "block.minecraft.pale_moss_carpet": "Tapete de musgo esbrancuxado",
  "block.minecraft.pale_oak_button": "Botón de carballo esbrancuxado",
  "block.minecraft.pale_oak_door": "Porta de carballo esbrancuxado",
  "block.minecraft.pale_oak_fence": "Valado de carballo esbrancuxado",
  "block.minecraft.pale_oak_fence_gate": "Cancela de carballo esbrancuxado",
  "block.minecraft.pale_oak_hanging_sign": "Letreiro colgante de carballo esbrancuxado",
  "block.minecraft.pale_oak_leaves": "Follas de carballo esbrancuxado",
  "block.minecraft.pale_oak_log": "Tronco de carballo esbrancuxado",
  "block.minecraft.pale_oak_planks": "Táboas de carballo esbrancuxado",
  "block.minecraft.pale_oak_pressure_plate": "Placa de presión de carballo esbrancuxado",
  "block.minecraft.pale_oak_sapling": "Gromo de carballo esbrancuxado",
  "block.minecraft.pale_oak_shelf": "Andel de carballo esbrancuxado",
  "block.minecraft.pale_oak_sign": "Letreiro de carballo esbrancuxado",
  "block.minecraft.pale_oak_slab": "Lastra de carballo esbrancuxado",
  "block.minecraft.pale_oak_stairs": "Escaleiras de carballo esbrancuxado",
  "block.minecraft.pale_oak_trapdoor": "Zapón de carballo esbrancuxado",
  "block.minecraft.pale_oak_wall_hanging_sign": "Letreiro colgante de carballo esbrancuxado de parede",
  "block.minecraft.pale_oak_wall_sign": "Letreiro de carballo esbrancuxado de parede",
  "block.minecraft.pale_oak_wood": "Madeira de carballo esbrancuxado",
  "block.minecraft.pearlescent_froglight": "Anfibrillo anacarado",
  "block.minecraft.peony": "Peonia",
  "block.minecraft.petrified_oak_slab": "Lastra de carballo petrificado",
  "block.minecraft.piglin_head": "Cabeza de piglin",
  "block.minecraft.piglin_wall_head": "Cabeza de piglin de parede",
  "block.minecraft.pink_banner": "Estandarte rosa",
  "block.minecraft.pink_bed": "Cama rosa",
  "block.minecraft.pink_candle": "Candea rosa",
  "block.minecraft.pink_candle_cake": "Torta con candea rosa",
  "block.minecraft.pink_carpet": "Alfombra rosa",
  "block.minecraft.pink_concrete": "Formigón rosa",
  "block.minecraft.pink_concrete_powder": "Cemento rosa",
  "block.minecraft.pink_glazed_terracotta": "Azulexo rosa",
  "block.minecraft.pink_petals": "Pétalos rosas",
  "block.minecraft.pink_shulker_box": "Caixa de shulker rosa",
  "block.minecraft.pink_stained_glass": "Vidro tinguido de rosa",
  "block.minecraft.pink_stained_glass_pane": "Panel de vidro tinguido de rosa",
  "block.minecraft.pink_terracotta": "Terracota rosa",
  "block.minecraft.pink_tulip": "Tulipán rosa",
  "block.minecraft.pink_wool": "La rosa",
  "block.minecraft.piston": "Pistón",
  "block.minecraft.piston_head": "Cabeza de pistón",
  "block.minecraft.pitcher_crop": "Cultivo de planta xerra",
  "block.minecraft.pitcher_plant": "Planta xerra",
  "block.minecraft.player_head": "Cabeza de xogador",
  "block.minecraft.player_head.named": "Cabeza de %s",
  "block.minecraft.player_wall_head": "Cabeza de xogador de parede",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Espeleotema afiado",
  "block.minecraft.polished_andesite": "Andesita puída",
  "block.minecraft.polished_andesite_slab": "Lastra de andesita puída",
  "block.minecraft.polished_andesite_stairs": "Escaleiras de andesita puída",
  "block.minecraft.polished_basalt": "Basalto puído",
  "block.minecraft.polished_blackstone": "Pedra negra puída",
  "block.minecraft.polished_blackstone_brick_slab": "Lastra de ladrillos de pedra negra puída",
  "block.minecraft.polished_blackstone_brick_stairs": "Escaleiras de ladrillos de pedra negra puída",
  "block.minecraft.polished_blackstone_brick_wall": "Muro de ladrillos de pedra negra puída",
  "block.minecraft.polished_blackstone_bricks": "Ladrillos de pedra negra puída",
  "block.minecraft.polished_blackstone_button": "Botón de pedra negra puída",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de presión de pedra negra puída",
  "block.minecraft.polished_blackstone_slab": "Lastra de pedra negra puída",
  "block.minecraft.polished_blackstone_stairs": "Escaleiras de pedra negra puída",
  "block.minecraft.polished_blackstone_wall": "Muro de pedra negra puída",
  "block.minecraft.polished_deepslate": "Lousa profunda puída",
  "block.minecraft.polished_deepslate_slab": "Lastra de lousa profunda puída",
  "block.minecraft.polished_deepslate_stairs": "Escaleiras de lousa profunda puída",
  "block.minecraft.polished_deepslate_wall": "Muro de lousa profunda puída",
  "block.minecraft.polished_diorite": "Diorita puída",
  "block.minecraft.polished_diorite_slab": "Lastra de diorita puída",
  "block.minecraft.polished_diorite_stairs": "Escaleiras de diorita puída",
  "block.minecraft.polished_granite": "Granito puído",
  "block.minecraft.polished_granite_slab": "Lastra de granito puído",
  "block.minecraft.polished_granite_stairs": "Escaleiras de granito puído",
  "block.minecraft.polished_tuff": "Tufo puído",
  "block.minecraft.polished_tuff_slab": "Lastra de tufo puído",
  "block.minecraft.polished_tuff_stairs": "Escaleiras de tufo puído",
  "block.minecraft.polished_tuff_wall": "Muro de tufo puído",
  "block.minecraft.poppy": "Papoula",
  "block.minecraft.potatoes": "Patacas",
  "block.minecraft.potted_acacia_sapling": "Testo con gromo de acacia",
  "block.minecraft.potted_allium": "Testo con allo bravo",
  "block.minecraft.potted_azalea_bush": "Testo con azalea",
  "block.minecraft.potted_azure_bluet": "Testo con rubiácea",
  "block.minecraft.potted_bamboo": "Testo con bambú",
  "block.minecraft.potted_birch_sapling": "Testo con gromo de bidueiro",
  "block.minecraft.potted_blue_orchid": "Testo con orquídea azul",
  "block.minecraft.potted_brown_mushroom": "Testo con cogomelo marrón",
  "block.minecraft.potted_cactus": "Testo con cacto",
  "block.minecraft.potted_cherry_sapling": "Testo con gromo de cerdeira",
  "block.minecraft.potted_closed_eyeblossom": "Testo con fitamel pechada",
  "block.minecraft.potted_cornflower": "Testo con cardafuso",
  "block.minecraft.potted_crimson_fungus": "Testo con fungo carmesí",
  "block.minecraft.potted_crimson_roots": "Testo con raíces carmesís",
  "block.minecraft.potted_dandelion": "Testo con mexacán",
  "block.minecraft.potted_dark_oak_sapling": "Testo con gromo de carballo escuro",
  "block.minecraft.potted_dead_bush": "Testo con arbusto morto",
  "block.minecraft.potted_fern": "Testo con fento",
  "block.minecraft.potted_flowering_azalea_bush": "Testo con azalea en flor",
  "block.minecraft.potted_golden_dandelion": "Testo con mexacán dourado",
  "block.minecraft.potted_jungle_sapling": "Testo con gromo de selva",
  "block.minecraft.potted_lily_of_the_valley": "Testo con lirio dos vales",
  "block.minecraft.potted_mangrove_propagule": "Testo con propágulo de mangleiro",
  "block.minecraft.potted_oak_sapling": "Testo con gromo de carballo",
  "block.minecraft.potted_open_eyeblossom": "Testo con fitamel aberta",
  "block.minecraft.potted_orange_tulip": "Testo con tulipán laranxa",
  "block.minecraft.potted_oxeye_daisy": "Testo con margarida",
  "block.minecraft.potted_pale_oak_sapling": "Testo con gromo de carballo esbrancuxado",
  "block.minecraft.potted_pink_tulip": "Testo con tulipán rosa",
  "block.minecraft.potted_poppy": "Testo con papoula",
  "block.minecraft.potted_red_mushroom": "Testo con cogomelo vermello",
  "block.minecraft.potted_red_tulip": "Testo con tulipán vermello",
  "block.minecraft.potted_spruce_sapling": "Testo con gromo de abeto",
  "block.minecraft.potted_torchflower": "Testo con planta de lume",
  "block.minecraft.potted_warped_fungus": "Testo con fungo deformado",
  "block.minecraft.potted_warped_roots": "Testo con raíces deformadas",
  "block.minecraft.potted_white_tulip": "Testo con tulipán branco",
  "block.minecraft.potted_wither_rose": "Testo con rosa do Wither",
  "block.minecraft.powder_snow": "Neve en po",
  "block.minecraft.powder_snow_cauldron": "Caldeiro de neve en po",
  "block.minecraft.powered_rail": "Raíl propulsor",
  "block.minecraft.prismarine": "Prismariña",
  "block.minecraft.prismarine_brick_slab": "Lastra de ladrillos de prismariña",
  "block.minecraft.prismarine_brick_stairs": "Escaleiras de ladrillos de prismariña",
  "block.minecraft.prismarine_bricks": "Ladrillos de prismariña",
  "block.minecraft.prismarine_slab": "Lastra de prismariña",
  "block.minecraft.prismarine_stairs": "Escaleiras de prismariña",
  "block.minecraft.prismarine_wall": "Muro de prismariña",
  "block.minecraft.pumpkin": "Cabaza",
  "block.minecraft.pumpkin_stem": "Talo de cabaza",
  "block.minecraft.purple_banner": "Estandarte púrpura",
  "block.minecraft.purple_bed": "Cama púrpura",
  "block.minecraft.purple_candle": "Candea púrpura",
  "block.minecraft.purple_candle_cake": "Torta con candea púrpura",
  "block.minecraft.purple_carpet": "Alfombra púrpura",
  "block.minecraft.purple_concrete": "Formigón púrpura",
  "block.minecraft.purple_concrete_powder": "Cemento púrpura",
  "block.minecraft.purple_glazed_terracotta": "Azulexo púrpura",
  "block.minecraft.purple_shulker_box": "Caixa de shulker púrpura",
  "block.minecraft.purple_stained_glass": "Vidro tinguido de púrpura",
  "block.minecraft.purple_stained_glass_pane": "Panel de vidro tinguido de púrpura",
  "block.minecraft.purple_terracotta": "Terracota púrpura",
  "block.minecraft.purple_wool": "La púrpura",
  "block.minecraft.purpur_block": "Bloque de púrpur",
  "block.minecraft.purpur_pillar": "Piar de púrpur",
  "block.minecraft.purpur_slab": "Lastra de púrpur",
  "block.minecraft.purpur_stairs": "Escaleiras de púrpur",
  "block.minecraft.quartz_block": "Bloque de cuarzo",
  "block.minecraft.quartz_bricks": "Ladrillos de cuarzo",
  "block.minecraft.quartz_pillar": "Piar de cuarzo",
  "block.minecraft.quartz_slab": "Lastra de cuarzo",
  "block.minecraft.quartz_stairs": "Escaleiras de cuarzo",
  "block.minecraft.rail": "Raíl",
  "block.minecraft.raw_copper_block": "Bloque de cobre cru",
  "block.minecraft.raw_gold_block": "Bloque de ouro cru",
  "block.minecraft.raw_iron_block": "Bloque de ferro cru",
  "block.minecraft.red_banner": "Estandarte vermello",
  "block.minecraft.red_bed": "Cama vermella",
  "block.minecraft.red_candle": "Candea vermella",
  "block.minecraft.red_candle_cake": "Torta con candea vermella",
  "block.minecraft.red_carpet": "Alfombra vermella",
  "block.minecraft.red_concrete": "Formigón vermello",
  "block.minecraft.red_concrete_powder": "Cemento vermello",
  "block.minecraft.red_glazed_terracotta": "Azulexo vermello",
  "block.minecraft.red_mushroom": "Cogomelo vermello",
  "block.minecraft.red_mushroom_block": "Bloque de cogomelo vermello",
  "block.minecraft.red_nether_brick_slab": "Lastra de ladrillos do Nether vermellos",
  "block.minecraft.red_nether_brick_stairs": "Escaleiras de ladrillos do Nether vermellos",
  "block.minecraft.red_nether_brick_wall": "Muro de ladrillos do Nether vermellos",
  "block.minecraft.red_nether_bricks": "Ladrillos do Nether vermellos",
  "block.minecraft.red_sand": "Area vermella",
  "block.minecraft.red_sandstone": "Arenito vermello",
  "block.minecraft.red_sandstone_slab": "Lastra de arenito vermello",
  "block.minecraft.red_sandstone_stairs": "Escaleiras de arenito vermello",
  "block.minecraft.red_sandstone_wall": "Muro de arenito vermello",
  "block.minecraft.red_shulker_box": "Caixa de shulker vermella",
  "block.minecraft.red_stained_glass": "Vidro tinguido de vermello",
  "block.minecraft.red_stained_glass_pane": "Panel de vidro tinguido de vermello",
  "block.minecraft.red_terracotta": "Terracota vermella",
  "block.minecraft.red_tulip": "Tulipán vermello",
  "block.minecraft.red_wool": "La vermella",
  "block.minecraft.redstone_block": "Bloque de redstone",
  "block.minecraft.redstone_lamp": "Lámpada de redstone",
  "block.minecraft.redstone_ore": "Mineral de redstone",
  "block.minecraft.redstone_torch": "Facho de redstone",
  "block.minecraft.redstone_wall_torch": "Facho de redstone de parede",
  "block.minecraft.redstone_wire": "Fío de redstone",
  "block.minecraft.reinforced_deepslate": "Lousa profunda reforzada",
  "block.minecraft.repeater": "Repetidor de redstone",
  "block.minecraft.repeating_command_block": "Bloque de comandos de repetición",
  "block.minecraft.resin_block": "Bloque de recina",
  "block.minecraft.resin_brick_slab": "Lastra de ladrillos de recina",
  "block.minecraft.resin_brick_stairs": "Escaleiras de ladrillos de recina",
  "block.minecraft.resin_brick_wall": "Muro de ladrillos de recina",
  "block.minecraft.resin_bricks": "Ladrillos de recina",
  "block.minecraft.resin_clump": "Torolo de recina",
  "block.minecraft.respawn_anchor": "Áncora de reaparición",
  "block.minecraft.rooted_dirt": "Terra enraizada",
  "block.minecraft.rose_bush": "Roseira",
  "block.minecraft.sand": "Area",
  "block.minecraft.sandstone": "Arenito",
  "block.minecraft.sandstone_slab": "Lastra de arenito",
  "block.minecraft.sandstone_stairs": "Escaleiras de arenito",
  "block.minecraft.sandstone_wall": "Muro de arenito",
  "block.minecraft.scaffolding": "Estada",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizador de sculk",
  "block.minecraft.sculk_sensor": "Sensor de sculk",
  "block.minecraft.sculk_shrieker": "Alarma de sculk",
  "block.minecraft.sculk_vein": "Vea de sculk",
  "block.minecraft.sea_lantern": "Lanterna mariña",
  "block.minecraft.sea_pickle": "Cogombro de mar",
  "block.minecraft.seagrass": "Herba mariña",
  "block.minecraft.set_spawn": "Punto de reaparición estabelecido",
  "block.minecraft.short_dry_grass": "Herba seca baixa",
  "block.minecraft.short_grass": "Herba baixa",
  "block.minecraft.shroomlight": "Cogubrillo",
  "block.minecraft.shulker_box": "Caixa de shulker",
  "block.minecraft.skeleton_skull": "Caveira de esqueleto",
  "block.minecraft.skeleton_wall_skull": "Caveira de esqueleto de parede",
  "block.minecraft.slime_block": "Bloque de slime",
  "block.minecraft.small_amethyst_bud": "Gromo de ametista pequeno",
  "block.minecraft.small_dripleaf": "Planta pingueira pequena",
  "block.minecraft.smithing_table": "Mesa de ferraría",
  "block.minecraft.smoker": "Afumadoiro",
  "block.minecraft.smooth_basalt": "Basalto liso",
  "block.minecraft.smooth_quartz": "Bloque de cuarzo liso",
  "block.minecraft.smooth_quartz_slab": "Lastra de cuarzo liso",
  "block.minecraft.smooth_quartz_stairs": "Escaleiras de cuarzo liso",
  "block.minecraft.smooth_red_sandstone": "Arenito vermello liso",
  "block.minecraft.smooth_red_sandstone_slab": "Lastra de arenito vermello liso",
  "block.minecraft.smooth_red_sandstone_stairs": "Escaleiras de arenito vermello liso",
  "block.minecraft.smooth_sandstone": "Arenito liso",
  "block.minecraft.smooth_sandstone_slab": "Lastra de arenito liso",
  "block.minecraft.smooth_sandstone_stairs": "Escaleiras de arenito liso",
  "block.minecraft.smooth_stone": "Pedra lisa",
  "block.minecraft.smooth_stone_slab": "Lastra de pedra lisa",
  "block.minecraft.sniffer_egg": "Ovo de cheirador",
  "block.minecraft.snow": "Neve",
  "block.minecraft.snow_block": "Bloque de neve",
  "block.minecraft.soul_campfire": "Cacharela de ánimas",
  "block.minecraft.soul_fire": "Lume de ánimas",
  "block.minecraft.soul_lantern": "Lanterna de ánimas",
  "block.minecraft.soul_sand": "Area de ánimas",
  "block.minecraft.soul_soil": "Terra de ánimas",
  "block.minecraft.soul_torch": "Facho de ánimas",
  "block.minecraft.soul_wall_torch": "Facho de ánimas de parede",
  "block.minecraft.spawn.not_valid": "Non tes cama ou áncora de reaparición, ou estaban obstruídas",
  "block.minecraft.spawner": "Invocador de monstros",
  "block.minecraft.spawner.desc1": "Interactúa cun ovo de invocación:",
  "block.minecraft.spawner.desc2": "Estabelece o tipo de criatura",
  "block.minecraft.sponge": "Esponxa",
  "block.minecraft.spore_blossom": "Flor de esporas",
  "block.minecraft.spruce_button": "Botón de abeto",
  "block.minecraft.spruce_door": "Porta de abeto",
  "block.minecraft.spruce_fence": "Valado de abeto",
  "block.minecraft.spruce_fence_gate": "Cancela de abeto",
  "block.minecraft.spruce_hanging_sign": "Letreiro colgante de abeto",
  "block.minecraft.spruce_leaves": "Follas de abeto",
  "block.minecraft.spruce_log": "Tronco de abeto",
  "block.minecraft.spruce_planks": "Táboas de abeto",
  "block.minecraft.spruce_pressure_plate": "Placa de presión de abeto",
  "block.minecraft.spruce_sapling": "Gromo de abeto",
  "block.minecraft.spruce_shelf": "Andel de abeto",
  "block.minecraft.spruce_sign": "Letreiro de abeto",
  "block.minecraft.spruce_slab": "Lastra de abeto",
  "block.minecraft.spruce_stairs": "Escaleiras de abeto",
  "block.minecraft.spruce_trapdoor": "Zapón de abeto",
  "block.minecraft.spruce_wall_hanging_sign": "Letreiro colgante de abeto de parede",
  "block.minecraft.spruce_wall_sign": "Letreiro de abeto de parede",
  "block.minecraft.spruce_wood": "Madeira de abeto",
  "block.minecraft.sticky_piston": "Pistón pegañento",
  "block.minecraft.stone": "Rocha",
  "block.minecraft.stone_brick_slab": "Lastra de ladrillos de pedra",
  "block.minecraft.stone_brick_stairs": "Escaleiras de ladrillos de pedra",
  "block.minecraft.stone_brick_wall": "Muro de ladrillos de pedra",
  "block.minecraft.stone_bricks": "Ladrillos de pedra",
  "block.minecraft.stone_button": "Botón de pedra",
  "block.minecraft.stone_pressure_plate": "Placa de presión de pedra",
  "block.minecraft.stone_slab": "Lastra de rocha",
  "block.minecraft.stone_stairs": "Escaleiras de rocha",
  "block.minecraft.stonecutter": "Cortapedras",
  "block.minecraft.stripped_acacia_log": "Tronco de acacia sen cortiza",
  "block.minecraft.stripped_acacia_wood": "Madeira de acacia sen cortiza",
  "block.minecraft.stripped_bamboo_block": "Bloque de bambú sen cortiza",
  "block.minecraft.stripped_birch_log": "Tronco de bidueiro sen cortiza",
  "block.minecraft.stripped_birch_wood": "Madeira de bidueiro sen cortiza",
  "block.minecraft.stripped_cherry_log": "Tronco de cerdeira sen cortiza",
  "block.minecraft.stripped_cherry_wood": "Madeira de cereixa sen cortiza",
  "block.minecraft.stripped_crimson_hyphae": "Talo carmesí sen cortiza",
  "block.minecraft.stripped_crimson_stem": "Talo carmesí sen cortiza",
  "block.minecraft.stripped_dark_oak_log": "Tronco de carballo escuro sen cortiza",
  "block.minecraft.stripped_dark_oak_wood": "Madeira de carballo escuro sen cortiza",
  "block.minecraft.stripped_jungle_log": "Tronco de selva sen cortiza",
  "block.minecraft.stripped_jungle_wood": "Madeira de selva sen cortiza",
  "block.minecraft.stripped_mangrove_log": "Tronco de mangleiro sen cortiza",
  "block.minecraft.stripped_mangrove_wood": "Madeira de mangleiro sen cortiza",
  "block.minecraft.stripped_oak_log": "Tronco de carballo sen cortiza",
  "block.minecraft.stripped_oak_wood": "Madeira de carballo sen cortiza",
  "block.minecraft.stripped_pale_oak_log": "Tronco de carballo esbrancuxado sen cortiza",
  "block.minecraft.stripped_pale_oak_wood": "Madeira de carballo esbrancuxado sen cortiza",
  "block.minecraft.stripped_spruce_log": "Tronco de abeto sen cortiza",
  "block.minecraft.stripped_spruce_wood": "Madeira de abeto sen cortiza",
  "block.minecraft.stripped_warped_hyphae": "Hifas deformadas sen cortiza",
  "block.minecraft.stripped_warped_stem": "Talo deformado sen cortiza",
  "block.minecraft.structure_block": "Bloque de estrutura",
  "block.minecraft.structure_void": "Bloque baleiro",
  "block.minecraft.sugar_cane": "Cana de azucre",
  "block.minecraft.sunflower": "Xirasol",
  "block.minecraft.suspicious_gravel": "Cascallo sospeitoso",
  "block.minecraft.suspicious_sand": "Area sospeitosa",
  "block.minecraft.sweet_berry_bush": "Arbusto de bagas doces",
  "block.minecraft.tall_dry_grass": "Herba seca alta",
  "block.minecraft.tall_grass": "Herba alta",
  "block.minecraft.tall_seagrass": "Herba mariña alta",
  "block.minecraft.target": "Albo",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloque de probas",
  "block.minecraft.test_instance_block": "Bloque de instancia de probas",
  "block.minecraft.tinted_glass": "Vidro opaco",
  "block.minecraft.tnt": "Dinamita",
  "block.minecraft.tnt.disabled": "As explosións de dinamita están desactivadas",
  "block.minecraft.torch": "Facho",
  "block.minecraft.torchflower": "Planta de lume",
  "block.minecraft.torchflower_crop": "Cultivo de planta de lume",
  "block.minecraft.trapped_chest": "Cofre trampa",
  "block.minecraft.trial_spawner": "Invocador de desafío",
  "block.minecraft.tripwire": "Fío trampa",
  "block.minecraft.tripwire_hook": "Gancho de fío trampa",
  "block.minecraft.tube_coral": "Coral de tubo",
  "block.minecraft.tube_coral_block": "Bloque de coral de tubo",
  "block.minecraft.tube_coral_fan": "Gorgonia de tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia tubular de parede",
  "block.minecraft.tuff": "Tufo",
  "block.minecraft.tuff_brick_slab": "Lastra de ladrillos de tufo",
  "block.minecraft.tuff_brick_stairs": "Escaleiras de ladrillos de tufo",
  "block.minecraft.tuff_brick_wall": "Muro de ladrillos de tufo",
  "block.minecraft.tuff_bricks": "Ladrillos de tufo",
  "block.minecraft.tuff_slab": "Lastra de tufo",
  "block.minecraft.tuff_stairs": "Escaleiras de tufo",
  "block.minecraft.tuff_wall": "Muro de tufo",
  "block.minecraft.turtle_egg": "Ovo de tartaruga",
  "block.minecraft.twisting_vines": "Trepadeiras retortas",
  "block.minecraft.twisting_vines_plant": "Planta de trepadeiras retortas",
  "block.minecraft.vault": "Arca",
  "block.minecraft.verdant_froglight": "Anfibrillo verde",
  "block.minecraft.vine": "Trepadeiras",
  "block.minecraft.void_air": "Ar do baleiro",
  "block.minecraft.wall_torch": "Facho de parede",
  "block.minecraft.warped_button": "Botón deformado",
  "block.minecraft.warped_door": "Porta deformada",
  "block.minecraft.warped_fence": "Valado deformado",
  "block.minecraft.warped_fence_gate": "Cancela deformada",
  "block.minecraft.warped_fungus": "Fungo deformado",
  "block.minecraft.warped_hanging_sign": "Letreiro colgante deformado",
  "block.minecraft.warped_hyphae": "Hifas deformadas",
  "block.minecraft.warped_nylium": "Nicelio deformado",
  "block.minecraft.warped_planks": "Táboas deformadas",
  "block.minecraft.warped_pressure_plate": "Placa de presión deformada",
  "block.minecraft.warped_roots": "Raíces deformadas",
  "block.minecraft.warped_shelf": "Andel deformado",
  "block.minecraft.warped_sign": "Letreiro deformado",
  "block.minecraft.warped_slab": "Lastra deformada",
  "block.minecraft.warped_stairs": "Escaleiras deformadas",
  "block.minecraft.warped_stem": "Talo deformado",
  "block.minecraft.warped_trapdoor": "Zapón deformado",
  "block.minecraft.warped_wall_hanging_sign": "Letreiro colgante deformado de parede",
  "block.minecraft.warped_wall_sign": "Letreiro deformado de parede",
  "block.minecraft.warped_wart_block": "Bloque de espullas deformadas",
  "block.minecraft.water": "Auga",
  "block.minecraft.water_cauldron": "Caldeiro de auga",
  "block.minecraft.waxed_chiseled_copper": "Cobre cicelado encerado",
  "block.minecraft.waxed_copper_bars": "Barrotes de cobre encerado",
  "block.minecraft.waxed_copper_block": "Bloque de cobre encerado",
  "block.minecraft.waxed_copper_bulb": "Lámpada de cobre encerado",
  "block.minecraft.waxed_copper_chain": "Cadea de cobre encerado",
  "block.minecraft.waxed_copper_chest": "Cofre de cobre encerado",
  "block.minecraft.waxed_copper_door": "Porta de cobre encerado",
  "block.minecraft.waxed_copper_golem_statue": "Estatua de gólem de cobre encerada",
  "block.minecraft.waxed_copper_grate": "Reixa de cobre encerado",
  "block.minecraft.waxed_copper_lantern": "Lanterna de cobre encerado",
  "block.minecraft.waxed_copper_trapdoor": "Zapón de cobre encerado",
  "block.minecraft.waxed_cut_copper": "Cobre cortado encerado",
  "block.minecraft.waxed_cut_copper_slab": "Lastra de cobre cortado encerado",
  "block.minecraft.waxed_cut_copper_stairs": "Escaleiras de cobre encerado",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobre cicelado exposto encerado",
  "block.minecraft.waxed_exposed_copper": "Cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_bars": "Barrotes de cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_bulb": "Lámpada de cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_chain": "Cadea de cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_chest": "Cofre de cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_door": "Porta de cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estatua de gólem de cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_grate": "Reixa de cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_lantern": "Lanterna de cobre exposto encerado",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Zapón de cobre exposto e encerado",
  "block.minecraft.waxed_exposed_cut_copper": "Cobre cortado exposto encerado",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Lastra de cobre cortado exposto encerado",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escaleiras de cobre cortado exposto encerado",
  "block.minecraft.waxed_exposed_lightning_rod": "Pararraios exposto encerado",
  "block.minecraft.waxed_lightning_rod": "Pararraios encerado",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobre cicelado oxidado encerado",
  "block.minecraft.waxed_oxidized_copper": "Cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_bars": "Barrotes de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lámpada de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadea de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_chest": "Cofre de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_door": "Porta de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estatua de gólem de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_grate": "Reixa de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lanterna de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Zapón de cobre oxidado e encerado",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Lastra de cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escaleiras de cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pararraios oxidado encerado",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobre cicelado corroído encerado",
  "block.minecraft.waxed_weathered_copper": "Cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_bars": "Barrotes de cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_bulb": "Lámpada de cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_chain": "Cadea de cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_chest": "Cofre de cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_door": "Porta de cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estatua de gólem de cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_grate": "Reixa de cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_lantern": "Lanterna de cobre corroído encerado",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Zapón de cobre corroído e encerado",
  "block.minecraft.waxed_weathered_cut_copper": "Cobre cortado corroído encerado",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Lastra de cobre cortado corroído encerado",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escaleiras de cobre cortado corroído encerado",
  "block.minecraft.waxed_weathered_lightning_rod": "Pararraios corroído encerado",
  "block.minecraft.weathered_chiseled_copper": "Cobre cicelado corroído",
  "block.minecraft.weathered_copper": "Cobre corroído",
  "block.minecraft.weathered_copper_bars": "Barrotes de cobre corroído",
  "block.minecraft.weathered_copper_bulb": "Lámpada de cobre corroído",
  "block.minecraft.weathered_copper_chain": "Cadea de cobre corroído",
  "block.minecraft.weathered_copper_chest": "Cofre de cobre corroído",
  "block.minecraft.weathered_copper_door": "Porta de cobre corroído",
  "block.minecraft.weathered_copper_golem_statue": "Estatua de gólem de cobre corroído",
  "block.minecraft.weathered_copper_grate": "Reixa de cobre corroído",
  "block.minecraft.weathered_copper_lantern": "Lanterna de cobre corroído",
  "block.minecraft.weathered_copper_trapdoor": "Zapón de cobre corroído",
  "block.minecraft.weathered_cut_copper": "Cobre cortado corroído",
  "block.minecraft.weathered_cut_copper_slab": "Lastra de cobre cortado corroído",
  "block.minecraft.weathered_cut_copper_stairs": "Escaleiras de cobre cortado corroído",
  "block.minecraft.weathered_lightning_rod": "Pararraios corroído",
  "block.minecraft.weeping_vines": "Trepadeiras choronas",
  "block.minecraft.weeping_vines_plant": "Planta de trepadeiras choronas",
  "block.minecraft.wet_sponge": "Esponxa mollada",
  "block.minecraft.wheat": "Cultivos de trigo",
  "block.minecraft.white_banner": "Estandarte branco",
  "block.minecraft.white_bed": "Cama branca",
  "block.minecraft.white_candle": "Candea branca",
  "block.minecraft.white_candle_cake": "Torta con candea branca",
  "block.minecraft.white_carpet": "Alfombra branca",
  "block.minecraft.white_concrete": "Formigón branco",
  "block.minecraft.white_concrete_powder": "Cemento branco",
  "block.minecraft.white_glazed_terracotta": "Azulexo branco",
  "block.minecraft.white_shulker_box": "Caixa de shulker branca",
  "block.minecraft.white_stained_glass": "Vidro tinguido de branco",
  "block.minecraft.white_stained_glass_pane": "Panel de vidro tinguido de branco",
  "block.minecraft.white_terracotta": "Terracota branca",
  "block.minecraft.white_tulip": "Tulipán branco",
  "block.minecraft.white_wool": "La branca",
  "block.minecraft.wildflowers": "Flores silvestres",
  "block.minecraft.wither_rose": "Rosa do Wither",
  "block.minecraft.wither_skeleton_skull": "Caveira de esqueleto do Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Caveira de esqueleto do Wither de parede",
  "block.minecraft.yellow_banner": "Estandarte amarelo",
  "block.minecraft.yellow_bed": "Cama amarela",
  "block.minecraft.yellow_candle": "Candea amarela",
  "block.minecraft.yellow_candle_cake": "Torta con candea amarela",
  "block.minecraft.yellow_carpet": "Alfombra amarela",
  "block.minecraft.yellow_concrete": "Formigón amarelo",
  "block.minecraft.yellow_concrete_powder": "Cemento amarelo",
  "block.minecraft.yellow_glazed_terracotta": "Azulexo amarelo",
  "block.minecraft.yellow_shulker_box": "Caixa de shulker amarela",
  "block.minecraft.yellow_stained_glass": "Vidro tinguido de amarelo",
  "block.minecraft.yellow_stained_glass_pane": "Panel de vidro tinguido de amarelo",
  "block.minecraft.yellow_terracotta": "Terracota amarela",
  "block.minecraft.yellow_wool": "La amarela",
  "block.minecraft.zombie_head": "Cabeza de zombi",
  "block.minecraft.zombie_wall_head": "Cabeza de zombi de parede",
  "item.minecraft.acacia_boat": "Barca de acacia",
  "item.minecraft.acacia_chest_boat": "Barca de acacia con cofre",
  "item.minecraft.allay_spawn_egg": "Ovo de invocación de allay",
  "item.minecraft.amethyst_shard": "Fragmento de ametista",
  "item.minecraft.angler_pottery_shard": "Fragmento de cerámica de pescador",
  "item.minecraft.angler_pottery_sherd": "Fragmento de cerámica de pescador",
  "item.minecraft.apple": "Mazá",
  "item.minecraft.archer_pottery_shard": "Fragmento de cerámica de arqueiro",
  "item.minecraft.archer_pottery_sherd": "Fragmento de cerámica de arqueiro",
  "item.minecraft.armadillo_scute": "Escama de armadillo",
  "item.minecraft.armadillo_spawn_egg": "Ovo de invocación de armadillo",
  "item.minecraft.armor_stand": "Soporte de armadura",
  "item.minecraft.arms_up_pottery_shard": "Fragmento de cerámica de brazos arriba",
  "item.minecraft.arms_up_pottery_sherd": "Fragmento de cerámica de brazos arriba",
  "item.minecraft.arrow": "Frecha",
  "item.minecraft.axolotl_bucket": "Balde con axolote",
  "item.minecraft.axolotl_spawn_egg": "Ovo de invocación de axolote",
  "item.minecraft.baked_potato": "Pataca cociñada",
  "item.minecraft.bamboo_chest_raft": "Balsa de bambú con cofre",
  "item.minecraft.bamboo_raft": "Balsa de bambú",
  "item.minecraft.bat_spawn_egg": "Ovo de invocación de morcego",
  "item.minecraft.bee_spawn_egg": "Ovo de invocación de abella",
  "item.minecraft.beef": "Filete cru",
  "item.minecraft.beetroot": "Remolacha",
  "item.minecraft.beetroot_seeds": "Sementes de remolacha",
  "item.minecraft.beetroot_soup": "Sopa de remolacha",
  "item.minecraft.birch_boat": "Barca de bidueiro",
  "item.minecraft.birch_chest_boat": "Barca de bidueiro con cofre",
  "item.minecraft.black_bundle": "Saco negro",
  "item.minecraft.black_dye": "Tintura negra",
  "item.minecraft.black_harness": "Arreo negro",
  "item.minecraft.blade_pottery_shard": "Fragmento de cerámica de espada",
  "item.minecraft.blade_pottery_sherd": "Fragmento de cerámica de espada",
  "item.minecraft.blaze_powder": "Po de blaze",
  "item.minecraft.blaze_rod": "Vara de blaze",
  "item.minecraft.blaze_spawn_egg": "Ovo de invocación de blaze",
  "item.minecraft.blue_bundle": "Saco azul",
  "item.minecraft.blue_dye": "Tintura azul",
  "item.minecraft.blue_egg": "Ovo azul",
  "item.minecraft.blue_harness": "Arreo azul",
  "item.minecraft.bogged_spawn_egg": "Ovo de invocación de enlamado",
  "item.minecraft.bolt_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Deseño de parafuso",
  "item.minecraft.bone": "Óso",
  "item.minecraft.bone_meal": "Fariña de óso",
  "item.minecraft.book": "Libro",
  "item.minecraft.bordure_indented_banner_pattern": "Borde recortar do patrón de bandeira",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Cunca",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Vara de remuíño",
  "item.minecraft.breeze_spawn_egg": "Ovo de invocación de remuíño",
  "item.minecraft.brewer_pottery_shard": "Fragmento de cerámica de poción",
  "item.minecraft.brewer_pottery_sherd": "Fragmento de cerámica de poción",
  "item.minecraft.brewing_stand": "Fermentador",
  "item.minecraft.brick": "Ladrillo",
  "item.minecraft.brown_bundle": "Saco marrón",
  "item.minecraft.brown_dye": "Tintura marrón",
  "item.minecraft.brown_egg": "Ovo marrón",
  "item.minecraft.brown_harness": "Arreo marrón",
  "item.minecraft.brush": "Pincel",
  "item.minecraft.bucket": "Balde",
  "item.minecraft.bundle": "Saco",
  "item.minecraft.bundle.empty": "Baleiro",
  "item.minecraft.bundle.empty.description": "Pode conter un conxunto diverso de obxectos",
  "item.minecraft.bundle.full": "Cheo",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Fragmento de cerámica de lume",
  "item.minecraft.burn_pottery_sherd": "Fragmento de cerámica de lume",
  "item.minecraft.camel_husk_spawn_egg": "Ovo de invocación de camelo momia",
  "item.minecraft.camel_spawn_egg": "Ovo de invocación de camelo",
  "item.minecraft.carrot": "Cenoria",
  "item.minecraft.carrot_on_a_stick": "Cenoria nun pau",
  "item.minecraft.cat_spawn_egg": "Ovo de invocación de gato",
  "item.minecraft.cauldron": "Caldeiro",
  "item.minecraft.cave_spider_spawn_egg": "Ovo de invocación de araña de cova",
  "item.minecraft.chainmail_boots": "Botas de cota de malla",
  "item.minecraft.chainmail_chestplate": "Coiraza de cota de malla",
  "item.minecraft.chainmail_helmet": "Helmo de cota de mallas",
  "item.minecraft.chainmail_leggings": "Perneiras de cota de malla",
  "item.minecraft.charcoal": "Carbón vexetal",
  "item.minecraft.cherry_boat": "Barca de cerdeira",
  "item.minecraft.cherry_chest_boat": "Barca de cerdeira con cofre",
  "item.minecraft.chest_minecart": "Vagoneta con cofre",
  "item.minecraft.chicken": "Polo cru",
  "item.minecraft.chicken_spawn_egg": "Ovo de invocación de galiña",
  "item.minecraft.chorus_fruit": "Froita coral",
  "item.minecraft.clay_ball": "Bóla de arxila",
  "item.minecraft.clock": "Reloxo",
  "item.minecraft.coal": "Carbón",
  "item.minecraft.coast_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Deseño costeiro",
  "item.minecraft.cocoa_beans": "Sementes de cacao",
  "item.minecraft.cod": "Bacallau cru",
  "item.minecraft.cod_bucket": "Balde con bacallau",
  "item.minecraft.cod_spawn_egg": "Ovo de invocación de bacallau",
  "item.minecraft.command_block_minecart": "Vagoneta con bloque de comandos",
  "item.minecraft.compass": "Compás",
  "item.minecraft.cooked_beef": "Filete cociñado",
  "item.minecraft.cooked_chicken": "Polo cociñado",
  "item.minecraft.cooked_cod": "Bacallau cociñado",
  "item.minecraft.cooked_mutton": "Cordeiro cociñado",
  "item.minecraft.cooked_porkchop": "Costeleta de porco cociñada",
  "item.minecraft.cooked_rabbit": "Coello cociñado",
  "item.minecraft.cooked_salmon": "Salmón cociñado",
  "item.minecraft.cookie": "Galleta",
  "item.minecraft.copper_axe": "Machada de cobre",
  "item.minecraft.copper_boots": "Botas de cobre",
  "item.minecraft.copper_chestplate": "Coiraza de cobre",
  "item.minecraft.copper_golem_spawn_egg": "Ovo de invocación de gólem de cobre",
  "item.minecraft.copper_helmet": "Helmo de cobre",
  "item.minecraft.copper_hoe": "Sacho de cobre",
  "item.minecraft.copper_horse_armor": "Armadura de cobre para cabalo",
  "item.minecraft.copper_ingot": "Lingote de cobre",
  "item.minecraft.copper_leggings": "Grebas de cobre",
  "item.minecraft.copper_nautilus_armor": "Armadura de cobre para náutilo",
  "item.minecraft.copper_nugget": "Pebida de cobre",
  "item.minecraft.copper_pickaxe": "Pico de cobre",
  "item.minecraft.copper_shovel": "Pa de cobre",
  "item.minecraft.copper_spear": "Lanza de cobre",
  "item.minecraft.copper_sword": "Espada de cobre",
  "item.minecraft.cow_spawn_egg": "Ovo de invocación de vaca",
  "item.minecraft.creaking_spawn_egg": "Ovo de invocación de crepitante",
  "item.minecraft.creeper_banner_pattern": "Deseño de estandarte",
  "item.minecraft.creeper_banner_pattern.desc": "Estampado de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Patrón de bandeira de Creeper",
  "item.minecraft.creeper_spawn_egg": "Ovo de invocación de creeper",
  "item.minecraft.crossbow": "Bésta",
  "item.minecraft.crossbow.projectile": "Proxectil:",
  "item.minecraft.crossbow.projectile.multiple": "Proxectil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proxectil: %s",
  "item.minecraft.cyan_bundle": "Saco ciano",
  "item.minecraft.cyan_dye": "Tintura ciano",
  "item.minecraft.cyan_harness": "Arreo ciano",
  "item.minecraft.danger_pottery_shard": "Fragmento de cerámica de perigo",
  "item.minecraft.danger_pottery_sherd": "Fragmento de cerámica de perigo",
  "item.minecraft.dark_oak_boat": "Barca de carballo escuro",
  "item.minecraft.dark_oak_chest_boat": "Barca de carballo escuro con cofre",
  "item.minecraft.debug_stick": "Pau de depuración",
  "item.minecraft.debug_stick.empty": "%s non ten propiedades",
  "item.minecraft.debug_stick.select": "seleccionouse \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" a %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Machada de diamante",
  "item.minecraft.diamond_boots": "Botas de diamante",
  "item.minecraft.diamond_chestplate": "Coiraza de diamante",
  "item.minecraft.diamond_helmet": "Helmo de diamante",
  "item.minecraft.diamond_hoe": "Sacho de diamante",
  "item.minecraft.diamond_horse_armor": "Armadura de diamante para cabalo",
  "item.minecraft.diamond_leggings": "Perneiras de diamante",
  "item.minecraft.diamond_nautilus_armor": "Armadura de diamante para náutilo",
  "item.minecraft.diamond_pickaxe": "Pico de diamante",
  "item.minecraft.diamond_shovel": "Pa de diamante",
  "item.minecraft.diamond_spear": "Lanza de diamante",
  "item.minecraft.diamond_sword": "Espada de diamante",
  "item.minecraft.disc_fragment_5": "Anaco de disco",
  "item.minecraft.disc_fragment_5.desc": "Disco de música - 5",
  "item.minecraft.dolphin_spawn_egg": "Ovo de invocación de golfiño",
  "item.minecraft.donkey_spawn_egg": "Ovo de invocación de burro",
  "item.minecraft.dragon_breath": "Bafo do dragón",
  "item.minecraft.dried_kelp": "Alga seca",
  "item.minecraft.drowned_spawn_egg": "Ovo de invocación de afogado",
  "item.minecraft.dune_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Deseño de dunas",
  "item.minecraft.echo_shard": "Fragmento de eco",
  "item.minecraft.egg": "Ovo",
  "item.minecraft.elder_guardian_spawn_egg": "Ovo de invocación de gardián ancián",
  "item.minecraft.elytra": "Élitros",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Libro encantado",
  "item.minecraft.enchanted_golden_apple": "Mazá de ouro encantada",
  "item.minecraft.end_crystal": "Cristal do End",
  "item.minecraft.ender_dragon_spawn_egg": "Ovo de invocación de dragón do Ender",
  "item.minecraft.ender_eye": "Ollo do Ender",
  "item.minecraft.ender_pearl": "Perla do Ender",
  "item.minecraft.enderman_spawn_egg": "Ovo de invocación de enderman",
  "item.minecraft.endermite_spawn_egg": "Ovo de invocación de endermite",
  "item.minecraft.evoker_spawn_egg": "Ovo de invocación de invocador",
  "item.minecraft.experience_bottle": "Frasco de experiencia",
  "item.minecraft.explorer_pottery_shard": "Fragmento de cerámica de explorador",
  "item.minecraft.explorer_pottery_sherd": "Fragmento de cerámica de explorador",
  "item.minecraft.eye_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Deseño de ollo",
  "item.minecraft.feather": "Pluma",
  "item.minecraft.fermented_spider_eye": "Ollo de araña fermentado",
  "item.minecraft.field_masoned_banner_pattern": "Patrón de bandeira de muro",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Bóla de lume",
  "item.minecraft.firework_rocket": "Foguete",
  "item.minecraft.firework_rocket.flight": "Duración do voo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Estrela de foguete",
  "item.minecraft.firework_star.black": "Negro",
  "item.minecraft.firework_star.blue": "Azul",
  "item.minecraft.firework_star.brown": "Marrón",
  "item.minecraft.firework_star.custom_color": "Personalizado",
  "item.minecraft.firework_star.cyan": "Ciano",
  "item.minecraft.firework_star.fade_to": "Esvaecemento",
  "item.minecraft.firework_star.flicker": "Refulxencia",
  "item.minecraft.firework_star.gray": "Gris",
  "item.minecraft.firework_star.green": "Verde",
  "item.minecraft.firework_star.light_blue": "Azul claro",
  "item.minecraft.firework_star.light_gray": "Gris claro",
  "item.minecraft.firework_star.lime": "Lima",
  "item.minecraft.firework_star.magenta": "Maxenta",
  "item.minecraft.firework_star.orange": "Laranxa",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Púrpura",
  "item.minecraft.firework_star.red": "Vermello",
  "item.minecraft.firework_star.shape": "Forma descoñecida",
  "item.minecraft.firework_star.shape.burst": "Impulso",
  "item.minecraft.firework_star.shape.creeper": "Forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bóla grande",
  "item.minecraft.firework_star.shape.small_ball": "Bóla pequena",
  "item.minecraft.firework_star.shape.star": "Forma de estrela",
  "item.minecraft.firework_star.trail": "Rastro",
  "item.minecraft.firework_star.white": "Branco",
  "item.minecraft.firework_star.yellow": "Amarelo",
  "item.minecraft.fishing_rod": "Cana de pescar",
  "item.minecraft.flint": "Pedernal",
  "item.minecraft.flint_and_steel": "Chisqueiro",
  "item.minecraft.flow_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Deseño de remuíño",
  "item.minecraft.flow_banner_pattern": "Deseño de estandarte",
  "item.minecraft.flow_banner_pattern.desc": "Espiral",
  "item.minecraft.flow_banner_pattern.new": "Patròn de bandeira de remolino",
  "item.minecraft.flow_pottery_sherd": "Fragmento de cerámica de remuíño",
  "item.minecraft.flower_banner_pattern": "Deseño de estandarte",
  "item.minecraft.flower_banner_pattern.desc": "Estampado de flor",
  "item.minecraft.flower_banner_pattern.new": "Patrón de bandeira de flores",
  "item.minecraft.flower_pot": "Testo",
  "item.minecraft.fox_spawn_egg": "Ovo de invocación de raposo",
  "item.minecraft.friend_pottery_shard": "Fragmento de cerámica de amigo",
  "item.minecraft.friend_pottery_sherd": "Fragmento de cerámica de amigo",
  "item.minecraft.frog_spawn_egg": "Ovo de invocación de ra",
  "item.minecraft.furnace_minecart": "Vagoneta con forno",
  "item.minecraft.ghast_spawn_egg": "Ovo de invocación de ghast",
  "item.minecraft.ghast_tear": "Bágoa de ghast",
  "item.minecraft.glass_bottle": "Frasco de vidro",
  "item.minecraft.glistering_melon_slice": "Anaco de sandía relucente",
  "item.minecraft.globe_banner_pattern": "Deseño de estandarte",
  "item.minecraft.globe_banner_pattern.desc": "Estampado de planeta",
  "item.minecraft.globe_banner_pattern.new": "Patrón de bandeira de globo",
  "item.minecraft.glow_berries": "Bagas brillantes",
  "item.minecraft.glow_ink_sac": "Saco de borra brillante",
  "item.minecraft.glow_item_frame": "Marco brillante",
  "item.minecraft.glow_squid_spawn_egg": "Ovo de invocación de lura brillante",
  "item.minecraft.glowstone_dust": "Po de pedra luminosa",
  "item.minecraft.goat_horn": "Corno de cabra",
  "item.minecraft.goat_spawn_egg": "Ovo de invocación de cabra",
  "item.minecraft.gold_ingot": "Lingote de ouro",
  "item.minecraft.gold_nugget": "Pebida de ouro",
  "item.minecraft.golden_apple": "Mazá dourada",
  "item.minecraft.golden_axe": "Machada de ouro",
  "item.minecraft.golden_boots": "Botas de ouro",
  "item.minecraft.golden_carrot": "Cenoria dourada",
  "item.minecraft.golden_chestplate": "Coiraza de ouro",
  "item.minecraft.golden_helmet": "Helmo de ouro",
  "item.minecraft.golden_hoe": "Sacho de ouro",
  "item.minecraft.golden_horse_armor": "Armadura de ouro para cabalo",
  "item.minecraft.golden_leggings": "Perneiras de ouro",
  "item.minecraft.golden_nautilus_armor": "Armadura de ouro para náutilo",
  "item.minecraft.golden_pickaxe": "Pico de ouro",
  "item.minecraft.golden_shovel": "Pa de ouro",
  "item.minecraft.golden_spear": "Lanza de ouro",
  "item.minecraft.golden_sword": "Espada de ouro",
  "item.minecraft.gray_bundle": "Saco gris",
  "item.minecraft.gray_dye": "Tintura gris",
  "item.minecraft.gray_harness": "Arreo gris",
  "item.minecraft.green_bundle": "Saco verde",
  "item.minecraft.green_dye": "Tintura verde",
  "item.minecraft.green_harness": "Arreo verde",
  "item.minecraft.guardian_spawn_egg": "Ovo de invocación de gardián",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Deseño do estandarte",
  "item.minecraft.guster_banner_pattern.desc": "Remuíño",
  "item.minecraft.guster_banner_pattern.new": "Patrón de estandarte de remuíño",
  "item.minecraft.guster_pottery_sherd": "Fragmento de cerámica de remuíño",
  "item.minecraft.happy_ghast_spawn_egg": "Ovo de invocación de ghast ledo",
  "item.minecraft.harness": "Arreo",
  "item.minecraft.heart_of_the_sea": "Corazón do océano",
  "item.minecraft.heart_pottery_shard": "Fragmento de cerámica de corazón",
  "item.minecraft.heart_pottery_sherd": "Fragmento de cerámica de corazón",
  "item.minecraft.heartbreak_pottery_shard": "Fragmento de cerámica de corazón escachado",
  "item.minecraft.heartbreak_pottery_sherd": "Fragmento de cerámica de corazón escachado",
  "item.minecraft.hoglin_spawn_egg": "Ovo de invocación de hoglin",
  "item.minecraft.honey_bottle": "Frasco de mel",
  "item.minecraft.honeycomb": "Favo",
  "item.minecraft.hopper_minecart": "Vagoneta con funil",
  "item.minecraft.horse_spawn_egg": "Ovo de invocación de cabalo",
  "item.minecraft.host_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.host_armor_trim_smithing_template.new": "Deseño de anfitrión",
  "item.minecraft.howl_pottery_shard": "Fragmento de cerámica de ouveo",
  "item.minecraft.howl_pottery_sherd": "Fragmento de cerámica de ouveo",
  "item.minecraft.husk_spawn_egg": "Ovo de invocación de momia",
  "item.minecraft.ink_sac": "Saco de borra",
  "item.minecraft.iron_axe": "Machada de ferro",
  "item.minecraft.iron_boots": "Botas de ferro",
  "item.minecraft.iron_chestplate": "Coiraza de ferro",
  "item.minecraft.iron_golem_spawn_egg": "Ovo de invocación de gólem de ferro",
  "item.minecraft.iron_helmet": "Helmo de ferro",
  "item.minecraft.iron_hoe": "Sacho de ferro",
  "item.minecraft.iron_horse_armor": "Armadura de ferro para cabalo",
  "item.minecraft.iron_ingot": "Lingote de ferro",
  "item.minecraft.iron_leggings": "Perneiras de ferro",
  "item.minecraft.iron_nautilus_armor": "Armadura de ferro para náutilo",
  "item.minecraft.iron_nugget": "Pebida de ferro",
  "item.minecraft.iron_pickaxe": "Pico de ferro",
  "item.minecraft.iron_shovel": "Pa de ferro",
  "item.minecraft.iron_spear": "Lanza de ferro",
  "item.minecraft.iron_sword": "Espada de ferro",
  "item.minecraft.item_frame": "Marco",
  "item.minecraft.jungle_boat": "Barca de selva",
  "item.minecraft.jungle_chest_boat": "Barca da selva con cofre",
  "item.minecraft.knowledge_book": "Enciclopedia",
  "item.minecraft.lapis_lazuli": "Lapislázuli",
  "item.minecraft.lava_bucket": "Balde con lava",
  "item.minecraft.lead": "Renda",
  "item.minecraft.leather": "Coiro",
  "item.minecraft.leather_boots": "Botas de coiro",
  "item.minecraft.leather_chestplate": "Coiraza de coiro",
  "item.minecraft.leather_helmet": "Helmo de coiro",
  "item.minecraft.leather_horse_armor": "Armadura de coiro para cabalo",
  "item.minecraft.leather_leggings": "Perneiras de coiro",
  "item.minecraft.light_blue_bundle": "Saco azul claro",
  "item.minecraft.light_blue_dye": "Tintura azul claro",
  "item.minecraft.light_blue_harness": "Arreo azul claro",
  "item.minecraft.light_gray_bundle": "Saco gris claro",
  "item.minecraft.light_gray_dye": "Tintura gris claro",
  "item.minecraft.light_gray_harness": "Arreo gris claro",
  "item.minecraft.lime_bundle": "Saco lima",
  "item.minecraft.lime_dye": "Tintura lima",
  "item.minecraft.lime_harness": "Arreo lima",
  "item.minecraft.lingering_potion": "Poción prolongada",
  "item.minecraft.lingering_potion.effect.awkward": "Poción prolongada estraña",
  "item.minecraft.lingering_potion.effect.empty": "Poción prolongada non fabricable",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poción prolongada de resistencia ao lume",
  "item.minecraft.lingering_potion.effect.harming": "Poción prolongada de dano",
  "item.minecraft.lingering_potion.effect.healing": "Poción prolongada de curación",
  "item.minecraft.lingering_potion.effect.infested": "Poción prolongada de infestación",
  "item.minecraft.lingering_potion.effect.invisibility": "Poción prolongada de invisibilidade",
  "item.minecraft.lingering_potion.effect.leaping": "Poción prolongada de brinco",
  "item.minecraft.lingering_potion.effect.levitation": "Poción prolongada de levitación",
  "item.minecraft.lingering_potion.effect.luck": "Poción prolongada de sorte",
  "item.minecraft.lingering_potion.effect.mundane": "Poción prolongada vulgar",
  "item.minecraft.lingering_potion.effect.night_vision": "Poción prolongada de visión nocturna",
  "item.minecraft.lingering_potion.effect.oozing": "Poción prolongada pegañenta",
  "item.minecraft.lingering_potion.effect.poison": "Poción prolongada de veleno",
  "item.minecraft.lingering_potion.effect.regeneration": "Poción prolongada de rexeneración",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poción prolongada de caída lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Poción prolongada de lentitude",
  "item.minecraft.lingering_potion.effect.strength": "Poción prolongada de forza",
  "item.minecraft.lingering_potion.effect.swiftness": "Poción prolongada de velocidade",
  "item.minecraft.lingering_potion.effect.thick": "Poción prolongada mesta",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poción prolongada do mestre tartaruga",
  "item.minecraft.lingering_potion.effect.water": "Frasco prolongado de auga",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poción prolongada de respiración acuática",
  "item.minecraft.lingering_potion.effect.weakness": "Poción prolongada de frouxidade",
  "item.minecraft.lingering_potion.effect.weaving": "Poción prolongada de tecedura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poción prolongada de carga de vento",
  "item.minecraft.llama_spawn_egg": "Ovo de invocación de llama",
  "item.minecraft.lodestone_compass": "Compás magnetizado",
  "item.minecraft.mace": "Clava",
  "item.minecraft.magenta_bundle": "Saco maxenta",
  "item.minecraft.magenta_dye": "Tintura maxenta",
  "item.minecraft.magenta_harness": "Arreo maxenta",
  "item.minecraft.magma_cream": "Crema de magma",
  "item.minecraft.magma_cube_spawn_egg": "Ovo de invocación de cubo de magma",
  "item.minecraft.mangrove_boat": "Barca de mangleiro",
  "item.minecraft.mangrove_chest_boat": "Barca de mangleiro con cofre",
  "item.minecraft.map": "Mapa baleiro",
  "item.minecraft.melon_seeds": "Sementes de sandía",
  "item.minecraft.melon_slice": "Anaco de sandía",
  "item.minecraft.milk_bucket": "Balde con leite",
  "item.minecraft.minecart": "Vagoneta",
  "item.minecraft.miner_pottery_shard": "Fragmento de cerámica de mineiro",
  "item.minecraft.miner_pottery_sherd": "Fragmento de cerámica de mineiro",
  "item.minecraft.mojang_banner_pattern": "Deseño de estandarte",
  "item.minecraft.mojang_banner_pattern.desc": "Símbolo de Mojang",
  "item.minecraft.mojang_banner_pattern.new": "Patrón de bandeira de chintófano",
  "item.minecraft.mooshroom_spawn_egg": "Ovo de invocación de mooshroom",
  "item.minecraft.mourner_pottery_shard": "Fragmento de cerámica de carpideira",
  "item.minecraft.mourner_pottery_sherd": "Fragmento de cerámica de carpideira",
  "item.minecraft.mule_spawn_egg": "Ovo de invocación de mula",
  "item.minecraft.mushroom_stew": "Estufado de cogomelos",
  "item.minecraft.music_disc_11": "Disco de música",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disco de música",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disco de música",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disco de música",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disco de música",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disco de música",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disco de música",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco de música",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (caixa de música)",
  "item.minecraft.music_disc_far": "Disco de música",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disco de música",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disco de música",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disco de música",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disco de música",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disco de música",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disco de música",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disco de música",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disco de música",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disco de música",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disco de música",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disco de música",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disco de música",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Cordeiro cru",
  "item.minecraft.name_tag": "Etiqueta de nome",
  "item.minecraft.nautilus_shell": "Cuncha de náutilo",
  "item.minecraft.nautilus_spawn_egg": "Ovo de invocación de náutilo",
  "item.minecraft.nether_brick": "Ladrillos do Nether",
  "item.minecraft.nether_star": "Estrela do Nether",
  "item.minecraft.nether_wart": "Espulla do Nether",
  "item.minecraft.netherite_axe": "Machada de netherita",
  "item.minecraft.netherite_boots": "Botas de netherita",
  "item.minecraft.netherite_chestplate": "Coiraza de netherita",
  "item.minecraft.netherite_helmet": "Casco de netherita",
  "item.minecraft.netherite_hoe": "Sacho de netherita",
  "item.minecraft.netherite_horse_armor": "Armadura de Netherita para Cabalo",
  "item.minecraft.netherite_ingot": "Lingote de netherita",
  "item.minecraft.netherite_leggings": "Perneiras de netherita",
  "item.minecraft.netherite_nautilus_armor": "Armadura de netherita para náutilo",
  "item.minecraft.netherite_pickaxe": "Pico de netherita",
  "item.minecraft.netherite_scrap": "Anacos de netherita",
  "item.minecraft.netherite_shovel": "Pa de netherita",
  "item.minecraft.netherite_spear": "Lanza de netherita",
  "item.minecraft.netherite_sword": "Espada de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Molde de ferraría",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Mellora de netherita",
  "item.minecraft.oak_boat": "Barca de carballo",
  "item.minecraft.oak_chest_boat": "Barca de carballo con cofre",
  "item.minecraft.ocelot_spawn_egg": "Ovo de invocación de ocelote",
  "item.minecraft.ominous_bottle": "Frasco sombrío",
  "item.minecraft.ominous_trial_key": "Chave de desafío sombría",
  "item.minecraft.orange_bundle": "Saco laranxa",
  "item.minecraft.orange_dye": "Tintura laranxa",
  "item.minecraft.orange_harness": "Arreo laranxa",
  "item.minecraft.painting": "Cadro",
  "item.minecraft.pale_oak_boat": "Barca de carballo esbrancuxado",
  "item.minecraft.pale_oak_chest_boat": "Barca de carballo esbrancuxado con cofre",
  "item.minecraft.panda_spawn_egg": "Ovo de invocación de panda",
  "item.minecraft.paper": "Papel",
  "item.minecraft.parched_spawn_egg": "Ovo de invocación de esqueleto momia",
  "item.minecraft.parrot_spawn_egg": "Ovo de invocación de papagaio",
  "item.minecraft.phantom_membrane": "Membrana de pantasma",
  "item.minecraft.phantom_spawn_egg": "Ovo de invocación de pantasma",
  "item.minecraft.pig_spawn_egg": "Ovo de invocación de porco",
  "item.minecraft.piglin_banner_pattern": "Deseño de estandarte",
  "item.minecraft.piglin_banner_pattern.desc": "Fociño",
  "item.minecraft.piglin_banner_pattern.new": "Patrón de bandeira de fociño",
  "item.minecraft.piglin_brute_spawn_egg": "Ovo de invocación de piglin bruto",
  "item.minecraft.piglin_spawn_egg": "Ovo de invocación de piglin",
  "item.minecraft.pillager_spawn_egg": "Ovo de invocación de saqueador",
  "item.minecraft.pink_bundle": "Saco rosa",
  "item.minecraft.pink_dye": "Tintura rosa",
  "item.minecraft.pink_harness": "Arreo rosa",
  "item.minecraft.pitcher_plant": "Planta xerra",
  "item.minecraft.pitcher_pod": "Bulbo de planta xerra",
  "item.minecraft.plenty_pottery_shard": "Fragmento de cerámica de abundancia",
  "item.minecraft.plenty_pottery_sherd": "Fragmento de cerámica de abundancia",
  "item.minecraft.poisonous_potato": "Pataca velenosa",
  "item.minecraft.polar_bear_spawn_egg": "Ovo de invocación de oso polar",
  "item.minecraft.popped_chorus_fruit": "Flocos de froita coral",
  "item.minecraft.porkchop": "Costeleta de porco crúa",
  "item.minecraft.potato": "Pataca",
  "item.minecraft.potion": "Poción",
  "item.minecraft.potion.effect.awkward": "Poción estraña",
  "item.minecraft.potion.effect.empty": "Poción non fabricable",
  "item.minecraft.potion.effect.fire_resistance": "Poción de resistencia ao lume",
  "item.minecraft.potion.effect.harming": "Poción de dano",
  "item.minecraft.potion.effect.healing": "Poción de curación",
  "item.minecraft.potion.effect.infested": "Poción de infestación",
  "item.minecraft.potion.effect.invisibility": "Poción de invisibilidade",
  "item.minecraft.potion.effect.leaping": "Poción de brinco",
  "item.minecraft.potion.effect.levitation": "Poción de levitación",
  "item.minecraft.potion.effect.luck": "Poción de sorte",
  "item.minecraft.potion.effect.mundane": "Poción vulgar",
  "item.minecraft.potion.effect.night_vision": "Poción de visión nocturna",
  "item.minecraft.potion.effect.oozing": "Poción pegañenta",
  "item.minecraft.potion.effect.poison": "Poción de veleno",
  "item.minecraft.potion.effect.regeneration": "Poción de rexeneración",
  "item.minecraft.potion.effect.slow_falling": "Poción de caída lenta",
  "item.minecraft.potion.effect.slowness": "Poción de lentitude",
  "item.minecraft.potion.effect.strength": "Poción de forza",
  "item.minecraft.potion.effect.swiftness": "Poción de velocidade",
  "item.minecraft.potion.effect.thick": "Poción mesta",
  "item.minecraft.potion.effect.turtle_master": "Poción do mestre tartaruga",
  "item.minecraft.potion.effect.water": "Frasco de auga",
  "item.minecraft.potion.effect.water_breathing": "Poción de respiración acuática",
  "item.minecraft.potion.effect.weakness": "Poción de frouxidade",
  "item.minecraft.potion.effect.weaving": "Poción de tecedura",
  "item.minecraft.potion.effect.wind_charged": "Poción de carga de vento",
  "item.minecraft.pottery_shard_archer": "Fragmento de cerámica de arqueiro",
  "item.minecraft.pottery_shard_arms_up": "Fragmento de cerámica de brazos arriba",
  "item.minecraft.pottery_shard_prize": "Fragmento de cerámica de premio",
  "item.minecraft.pottery_shard_skull": "Fragmento de cerámica de caveira",
  "item.minecraft.powder_snow_bucket": "Balde con neve en po",
  "item.minecraft.prismarine_crystals": "Cristais de prismariña",
  "item.minecraft.prismarine_shard": "Anaco de prismariña",
  "item.minecraft.prize_pottery_shard": "Fragmento de cerámica de premio",
  "item.minecraft.prize_pottery_sherd": "Fragmento de cerámica de premio",
  "item.minecraft.pufferfish": "Peixe globo",
  "item.minecraft.pufferfish_bucket": "Balde con peixe globo",
  "item.minecraft.pufferfish_spawn_egg": "Ovo de invocación de peixe globo",
  "item.minecraft.pumpkin_pie": "Torta de cabaza",
  "item.minecraft.pumpkin_seeds": "Sementes de cabaza",
  "item.minecraft.purple_bundle": "Saco púrpura",
  "item.minecraft.purple_dye": "Tintura púrpura",
  "item.minecraft.purple_harness": "Arreo púrpura",
  "item.minecraft.quartz": "Cuarzo do Nether",
  "item.minecraft.rabbit": "Coello cru",
  "item.minecraft.rabbit_foot": "Pata de coello",
  "item.minecraft.rabbit_hide": "Pel de coello",
  "item.minecraft.rabbit_spawn_egg": "Ovo de invocación de coello",
  "item.minecraft.rabbit_stew": "Estufado de coello",
  "item.minecraft.raiser_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Deseño de elevación",
  "item.minecraft.ravager_spawn_egg": "Ovo de invocación de devastador",
  "item.minecraft.raw_copper": "Cobre cru",
  "item.minecraft.raw_gold": "Ouro cru",
  "item.minecraft.raw_iron": "Ferro cru",
  "item.minecraft.recovery_compass": "Compás de recuperación",
  "item.minecraft.red_bundle": "Saco vermello",
  "item.minecraft.red_dye": "Tintura vermella",
  "item.minecraft.red_harness": "Arreo vermello",
  "item.minecraft.redstone": "Po de redstone",
  "item.minecraft.resin_brick": "Ladrillo de recina",
  "item.minecraft.resin_clump": "Torolo de recina",
  "item.minecraft.rib_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Deseño de costelas",
  "item.minecraft.rotten_flesh": "Carne podre",
  "item.minecraft.saddle": "Sela",
  "item.minecraft.salmon": "Salmón cru",
  "item.minecraft.salmon_bucket": "Balde con salmón",
  "item.minecraft.salmon_spawn_egg": "Ovo de invocación de salmón",
  "item.minecraft.scrape_pottery_sherd": "Fragmento de cerámica de raspado",
  "item.minecraft.scute": "Escama",
  "item.minecraft.sentry_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Deseño de sentinela",
  "item.minecraft.shaper_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Deseño de modelador",
  "item.minecraft.sheaf_pottery_shard": "Fragmento de cerámica de palla",
  "item.minecraft.sheaf_pottery_sherd": "Fragmento de cerámica de palla",
  "item.minecraft.shears": "Tesoiras",
  "item.minecraft.sheep_spawn_egg": "Ovo de invocación de ovella",
  "item.minecraft.shelter_pottery_shard": "Fragmento de cerámica de refuxio",
  "item.minecraft.shelter_pottery_sherd": "Fragmento de cerámica de refuxio",
  "item.minecraft.shield": "Escudo",
  "item.minecraft.shield.black": "Escudo negro",
  "item.minecraft.shield.blue": "Escudo azul",
  "item.minecraft.shield.brown": "Escudo marrón",
  "item.minecraft.shield.cyan": "Escudo ciano",
  "item.minecraft.shield.gray": "Escudo gris",
  "item.minecraft.shield.green": "Escudo verde",
  "item.minecraft.shield.light_blue": "Escudo azul claro",
  "item.minecraft.shield.light_gray": "Escudo gris claro",
  "item.minecraft.shield.lime": "Escudo lima",
  "item.minecraft.shield.magenta": "Escudo maxenta",
  "item.minecraft.shield.orange": "Escudo laranxa",
  "item.minecraft.shield.pink": "Escudo rosa",
  "item.minecraft.shield.purple": "Escudo púrpura",
  "item.minecraft.shield.red": "Escudo vermello",
  "item.minecraft.shield.white": "Escudo branco",
  "item.minecraft.shield.yellow": "Escudo amarelo",
  "item.minecraft.shulker_shell": "Cuncha de shulker",
  "item.minecraft.shulker_spawn_egg": "Ovo de invocación de shulker",
  "item.minecraft.sign": "Letreiro",
  "item.minecraft.silence_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Deseño de silencio",
  "item.minecraft.silverfish_spawn_egg": "Ovo de invocación de lepisma",
  "item.minecraft.skeleton_horse_spawn_egg": "Ovo de invocación de cabalo esqueleto",
  "item.minecraft.skeleton_spawn_egg": "Ovo de invocación de esqueleto",
  "item.minecraft.skull_banner_pattern": "Deseño de estandarte",
  "item.minecraft.skull_banner_pattern.desc": "Estampado de caveira",
  "item.minecraft.skull_banner_pattern.new": "Patrón de bandeira de caveira",
  "item.minecraft.skull_pottery_shard": "Fragmento de cerámica de caveira",
  "item.minecraft.skull_pottery_sherd": "Fragmento de cerámica de caveira",
  "item.minecraft.slime_ball": "Bóla de slime",
  "item.minecraft.slime_spawn_egg": "Ovo de invocación de slime",
  "item.minecraft.smithing_template": "Molde de ferraría",
  "item.minecraft.smithing_template.applies_to": "Aplica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Engade un lingote ou cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Engade unha peza de armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotes e cristais",
  "item.minecraft.smithing_template.ingredients": "Ingredientes:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Engade un lingote de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipamento de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Engade unha armadura, arma ou ferramenta de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingote de netherita",
  "item.minecraft.smithing_template.upgrade": "Mellora: ",
  "item.minecraft.sniffer_spawn_egg": "Ovo de invocación de cheirador",
  "item.minecraft.snort_pottery_shard": "Fragmento de cerámica de cheirador",
  "item.minecraft.snort_pottery_sherd": "Fragmento de cerámica de cheirador",
  "item.minecraft.snout_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Deseño de fociño",
  "item.minecraft.snow_golem_spawn_egg": "Ovo de invocación de gólem de neve",
  "item.minecraft.snowball": "Bóla de neve",
  "item.minecraft.spectral_arrow": "Frecha espectral",
  "item.minecraft.spider_eye": "Ollo de araña",
  "item.minecraft.spider_spawn_egg": "Ovo de invocación de araña",
  "item.minecraft.spire_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Deseño de agulla",
  "item.minecraft.splash_potion": "Poción guindable",
  "item.minecraft.splash_potion.effect.awkward": "Poción guindable estraña",
  "item.minecraft.splash_potion.effect.empty": "Poción guindable non fabricable",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poción guindable de resistencia ao lume",
  "item.minecraft.splash_potion.effect.harming": "Poción guindable de dano",
  "item.minecraft.splash_potion.effect.healing": "Poción guindable de curación",
  "item.minecraft.splash_potion.effect.infested": "Poción guindable de infestación",
  "item.minecraft.splash_potion.effect.invisibility": "Poción guindable de invisibilidade",
  "item.minecraft.splash_potion.effect.leaping": "Poción guindable de brinco",
  "item.minecraft.splash_potion.effect.levitation": "Poción guindable de levitación",
  "item.minecraft.splash_potion.effect.luck": "Poción guindable de sorte",
  "item.minecraft.splash_potion.effect.mundane": "Poción guindable vulgar",
  "item.minecraft.splash_potion.effect.night_vision": "Poción guindable de visión nocturna",
  "item.minecraft.splash_potion.effect.oozing": "Poción guindable pegañenta",
  "item.minecraft.splash_potion.effect.poison": "Poción guindable de veleno",
  "item.minecraft.splash_potion.effect.regeneration": "Poción guindable de rexeneración",
  "item.minecraft.splash_potion.effect.slow_falling": "Poción guindable de caída lenta",
  "item.minecraft.splash_potion.effect.slowness": "Poción guindable de lentitude",
  "item.minecraft.splash_potion.effect.strength": "Poción guindable de forza",
  "item.minecraft.splash_potion.effect.swiftness": "Poción guindable de velocidade",
  "item.minecraft.splash_potion.effect.thick": "Poción guindable mesta",
  "item.minecraft.splash_potion.effect.turtle_master": "Poción guindable do mestre tartaruga",
  "item.minecraft.splash_potion.effect.water": "Frasco guindable de auga",
  "item.minecraft.splash_potion.effect.water_breathing": "Poción guindable de respiración acuática",
  "item.minecraft.splash_potion.effect.weakness": "Poción guindable de frouxidade",
  "item.minecraft.splash_potion.effect.weaving": "Poción guindable de tecedura",
  "item.minecraft.splash_potion.effect.wind_charged": "Poción guindable de carga de vento",
  "item.minecraft.spruce_boat": "Barca de abeto",
  "item.minecraft.spruce_chest_boat": "Barca de abeto con cofre",
  "item.minecraft.spyglass": "Anteollos",
  "item.minecraft.squid_spawn_egg": "Ovo de invocación de lura",
  "item.minecraft.stick": "Pau",
  "item.minecraft.stone_axe": "Machada de pedra",
  "item.minecraft.stone_hoe": "Sacho de pedra",
  "item.minecraft.stone_pickaxe": "Pico de pedra",
  "item.minecraft.stone_shovel": "Pa de pedra",
  "item.minecraft.stone_spear": "Lanza de pedra",
  "item.minecraft.stone_sword": "Espada de pedra",
  "item.minecraft.stray_spawn_egg": "Ovo de invocación de esqueleto glacial",
  "item.minecraft.strider_spawn_egg": "Ovo de invocación de vagante",
  "item.minecraft.string": "Fío",
  "item.minecraft.sugar": "Azucre",
  "item.minecraft.suspicious_stew": "Estufado sospeitoso",
  "item.minecraft.sweet_berries": "Bagas doces",
  "item.minecraft.tadpole_bucket": "Balde de cágados",
  "item.minecraft.tadpole_spawn_egg": "Ovo de invocación de cágado",
  "item.minecraft.tide_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Deseño de marea",
  "item.minecraft.tipped_arrow": "Frecha con efecto",
  "item.minecraft.tipped_arrow.effect.awkward": "Frecha con auga estraña",
  "item.minecraft.tipped_arrow.effect.empty": "Frecha con efecto non fabricable",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Frecha de resistencia ao lume",
  "item.minecraft.tipped_arrow.effect.harming": "Frecha de dano",
  "item.minecraft.tipped_arrow.effect.healing": "Frecha de curación",
  "item.minecraft.tipped_arrow.effect.infested": "Frecha de infestación",
  "item.minecraft.tipped_arrow.effect.invisibility": "Frecha de invisibilidade",
  "item.minecraft.tipped_arrow.effect.leaping": "Frecha de brinco",
  "item.minecraft.tipped_arrow.effect.levitation": "Frecha de levitación",
  "item.minecraft.tipped_arrow.effect.luck": "Frecha de sorte",
  "item.minecraft.tipped_arrow.effect.mundane": "Frecha con efecto",
  "item.minecraft.tipped_arrow.effect.night_vision": "Frecha de visión nocturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Frecha pegañenta",
  "item.minecraft.tipped_arrow.effect.poison": "Frecha de veleno",
  "item.minecraft.tipped_arrow.effect.regeneration": "Frecha de rexeneración",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Frecha de caída lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Frecha de lentitude",
  "item.minecraft.tipped_arrow.effect.strength": "Frecha de forza",
  "item.minecraft.tipped_arrow.effect.swiftness": "Frecha de velocidade",
  "item.minecraft.tipped_arrow.effect.thick": "Frecha mesta",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Frecha do mestre tartaruga",
  "item.minecraft.tipped_arrow.effect.water": "Frecha sen efecto",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Frecha de respiración acuática",
  "item.minecraft.tipped_arrow.effect.weakness": "Frecha de frouxidade",
  "item.minecraft.tipped_arrow.effect.weaving": "Frecha de tecedura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Frecha de carga de vento",
  "item.minecraft.tnt_minecart": "Vagoneta con dinamita",
  "item.minecraft.torchflower_seeds": "Sementes de planta de lume",
  "item.minecraft.totem_of_undying": "Tótem da inmortalidade",
  "item.minecraft.trader_llama_spawn_egg": "Ovo de invocación de llama ambulante",
  "item.minecraft.trial_key": "Chave de desafío",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Peixe tropical",
  "item.minecraft.tropical_fish_bucket": "Balde con peixe tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Ovo de invocación de peixe tropical",
  "item.minecraft.turtle_helmet": "Cuncha de tartaruga",
  "item.minecraft.turtle_scute": "Escama de tartaruga",
  "item.minecraft.turtle_spawn_egg": "Ovo de invocación de tartaruga",
  "item.minecraft.vex_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Deseño de espírito",
  "item.minecraft.vex_spawn_egg": "Ovo de invocación de espírito",
  "item.minecraft.villager_spawn_egg": "Ovo de invocación de aldeán",
  "item.minecraft.vindicator_spawn_egg": "Ovo de invocación de vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "Ovo de invocación de vendedor ambulante",
  "item.minecraft.ward_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Molde de armadura de vixilante",
  "item.minecraft.warden_spawn_egg": "Ovo de invocación de vixilante",
  "item.minecraft.warped_fungus_on_a_stick": "Fungo deformado nun pau",
  "item.minecraft.water_bucket": "Balde con auga",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Deseño de guía",
  "item.minecraft.wheat": "Trigo",
  "item.minecraft.wheat_seeds": "Sementes de trigo",
  "item.minecraft.white_bundle": "Saco branco",
  "item.minecraft.white_dye": "Tintura branca",
  "item.minecraft.white_harness": "Arreo branco",
  "item.minecraft.wild_armor_trim_smithing_template": "Molde de ferraría",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Deseño salvaxe",
  "item.minecraft.wind_charge": "Carga de vento",
  "item.minecraft.witch_spawn_egg": "Ovo de invocación de meiga",
  "item.minecraft.wither_skeleton_spawn_egg": "Ovo de invocación de esqueleto do Wither",
  "item.minecraft.wither_spawn_egg": "Ovo de invocación de Wither",
  "item.minecraft.wolf_armor": "Armadura de lobo",
  "item.minecraft.wolf_spawn_egg": "Ovo de invocación de lobo",
  "item.minecraft.wooden_axe": "Machada de madeira",
  "item.minecraft.wooden_hoe": "Sacho de madeira",
  "item.minecraft.wooden_pickaxe": "Pico de madeira",
  "item.minecraft.wooden_shovel": "Pa de madeira",
  "item.minecraft.wooden_spear": "Lanza de madeira",
  "item.minecraft.wooden_sword": "Espada de madeira",
  "item.minecraft.writable_book": "Libro e pluma",
  "item.minecraft.written_book": "Libro escrito",
  "item.minecraft.yellow_bundle": "Saco amarelo",
  "item.minecraft.yellow_dye": "Tintura amarela",
  "item.minecraft.yellow_harness": "Arreo amarelo",
  "item.minecraft.zoglin_spawn_egg": "Ovo de invocación de zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ovo de invocación de cabalo zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Ovo de invocación de náutilo zombi",
  "item.minecraft.zombie_spawn_egg": "Ovo de invocación de zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Ovo de invocación de zombi aldeán",
  "item.minecraft.zombified_piglin_spawn_egg": "Ovo de invocación de piglin zombificado"
}
export const gl_es = items; 
